import React from "react";
import axios from "@/utils/myAxios";
import myUploadAxios from '@/utils/myUploadAxios'
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import {
    kindList,
    subKindList,
    handCardNumberList,
    profitTypeList,
    squidTypeList,
    gameTypeList,
    operModList,
    typeList,
} from "@/utils/constant";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

import {
    Button,
    Table,
    Pagination,
    message,
    Modal,
    Select,
    Input,
    Form,
    Switch,
    DatePicker,
    TimePicker,
    Slider,
    Radio,
    Alert,
    Row,
    Tooltip,
    Upload,
    Icon,
} from "antd";

/**
 * 验证是否是10的倍数
 */
const validateEntryFee = (rule, value, callback) => {
    if (value % 10 !== 0) {
        callback("请输入10的倍数！");
    } else {
        callback();
    }
};

/**
 * 禁用之前日期
 */
const disabledDate = (current) => {
    return current < moment().startOf("day");
};

// 表单数据
const formData = {
    name: undefined,
    game_type: 5,
    show_profit_type: 0,
    sub_kind: 1,
    oper_mod: 1,
    multiple: 0,
    blind: 0,
    ante: 0,
    ante_hang_value: 2,
    carry_range: [0, 0],
    min_carry: 0,
    min_play: 0,
    action_time: 0,
    match_time: 0,
    pot_fee_rate: 0,
    pot_fee_hand_limit: 0,
    auto_delay_times: 0,
    seat_num: 0,
    is_auto_start_user_num: false,
    auto_start_user_num: 0,
    is_unload_times: false,
    unload_times: 0,
    is_two_seven_bonus: false,
    two_seven_bonus: 0,
    is_rathole: false,
    rathole_minute: 0,
    is_call_time: false,
    call_time_profit: 0,
    call_time_lift_type: 1,
    call_time_lift_hand: 0,
    call_time_lift_minute: 0,
    is_boom: false,
    boom_range: [0, 0],
    boom_type: 1,
    boom_hand: 0,
    boom_minute: 0,
    is_sit_vpip: false,
    can_sit_vpip: 0,
    check_sit_vpip: 0,
    check_sit_vpip_begin_hand: 0,
    is_squid: false,
    squid_mode: 1,
    squid_bb: 0,
    is_sushi: false,
    sushi_base_ante: 0,
    sushi_seat_ante: 0,
    is_hang: false,
    magic_card: false,
    is_show_all_hands: false,
    random_seat: false,
    is_insurance: false,
    show_cowboy: false,
    force_blind: false,
    is_straddle: false,
    is_friend_limit: false,
    is_ip_gps_limit: false,
    is_close_chat: false,
    block_simulator: false,
    // auto_create_match: false,
};

const kindListFilter = kindList.filter(
    (item) => item.value !== 3 && item.value !== 5
);

let timer
export default class TableConfigList extends React.Component {
    state = {
        loading: false, // 是否加载中
        configLoading: false, // 配置是否加载中
        exportLoading: false, // 导出是否加载中
        exportAllLoading: false, // 导出所有是否加载中
        uploadConfigLoading: false, // 上传配置是否加载中
        show: false, // 是否显示弹窗
        showImport: false, // 是否显示导入弹窗
        showImportAll: false, // 是否显示导入多个弹窗
        title: undefined, // 标题
        importTitle: undefined, // 导入标题
        importAllTitle: undefined, // 导入多个标题
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            kind: 1,
        },
        kindList: kindListFilter, // 游戏类型列表
        subKindList: subKindList, // 游戏二级类型列表
        handCardNumberList: handCardNumberList, // 手牌数量
        profitTypeList: profitTypeList, // 即时战绩
        squidTypeList: squidTypeList, // 鱿鱼模式
        gameTypeList: gameTypeList, // 游戏模式
        operModList: operModList, // 操作顺序
        typeList: typeList, // 类型
        formData: { ...formData }, // 表单数据
        importAllformData: { // 导入所有表单数据
            uri: undefined,
        },
        uploadFile: {}, // 上传的文件
        data: [], // 表格数据
        configList: [], // 配置列表
        configData: {}, // 配置数据
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/create_match_conf", {
                params: {
                    ...this.state.queryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                if (res.data && res.data.length) {
                    res.data.forEach((item) => {
                        item.detail = JSON.parse(item.detail);
                    });
                }
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取配置列表
     */
    fetchConfigList = () => {
        // 轮询获取所有配置列表
        let page = 1
        let limit = 1000
        let isLoading = false
        let configList = []
        timer = setInterval(() => {
            if (isLoading) return
            isLoading = true
            axios.get("/v1/api/create_match_conf", {
                params: {
                    page,
                    limit,
                    kind: this.state.queryParams.kind,
                },
            }).then((res) => {
                page++
                res.data = res.data || []
                res.data.forEach((item) => {
                    item.detail = JSON.parse(item.detail);
                });
                configList = configList.concat(res.data)
                isLoading = false
                if (res.data.length < limit) {
                    clearInterval(timer)
                    this.setState({ configLoading: false, configList })
                }
            })
        })
    };

    /**
     * 获取配置数据
     */
    fetchConfigData = async () => {
        const res = await axios.get("/v1/api/default_create_match_conf", {
            params: {
                kind: this.state.queryParams.kind,
            },
        });
        if (res.code === 1) {
            const configData = res.data || {};
            configData.conf.minPlays = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

            // 初始化值
            const initFormData = { ...formData };
            // if (configData.conf.actionTimes && configData.conf.actionTimes.findIndex(item => item === configData.conf.default.actionTime) > 0) {
            //     initFormData.action_time = configData.conf.actionTimes.findIndex(item => item === configData.conf.default.actionTime)
            // }
            // // if (configData.conf.blinds && configData.conf.blinds.findIndex(item => item.bb === configData.conf.default.bb) > 0) {
            // //     initFormData.blind = configData.conf.blinds.findIndex(item => item.bb === configData.conf.default.bb)
            // // }
            // // if (configData.conf.actionTimes && configData.conf.actionTimes.findIndex(item => item === configData.conf.default.ante) > 0) {
            // //     initFormData.action_time = configData.conf.actionTimes.findIndex(item => item === configData.conf.default.ante)
            // // }
            // // if (configData.conf.actionTimes && configData.conf.actionTimes.findIndex(item => item === configData.conf.default.buyinMax) > 0) {
            // //     initFormData.action_time = configData.conf.actionTimes.findIndex(item => item === configData.conf.default.buyinMax)
            // // }
            // // if (configData.conf.actionTimes && configData.conf.actionTimes.findIndex(item => item === configData.conf.default.buyinMin) > 0) {
            // //     initFormData.action_time = configData.conf.actionTimes.findIndex(item => item === configData.conf.default.buyinMin)
            // // }
            // if (configData.conf.checkSitVpips && configData.conf.checkSitVpips.findIndex(item => item === configData.conf.default.checkSitVpip) > 0) {
            //     initFormData.check_sit_vpip = configData.conf.checkSitVpips.findIndex(item => item === configData.conf.default.checkSitVpip)
            // }
            // if (configData.conf.canSitVpips && configData.conf.canSitVpips.findIndex(item => item === configData.conf.default.canSitVpip) > 0) {
            //     initFormData.can_sit_vpip = configData.conf.canSitVpips.findIndex(item => item === configData.conf.default.canSitVpip)
            // }
            // if (configData.conf.checkSitVpipBeginHands && configData.conf.checkSitVpipBeginHands.findIndex(item => item === configData.conf.default.checkSitVpipBeginHand) > 0) {
            //     initFormData.check_sit_vpip_begin_hand = configData.conf.checkSitVpipBeginHands.findIndex(item => item === configData.conf.default.checkSitVpipBeginHand)
            // }
            // if (configData.conf.fantasyActionTimes && configData.conf.fantasyActionTimes.findIndex(item => item === configData.conf.default.fantasyActionTime) > 0) {
            //     initFormData.fantasy_action_time = configData.conf.fantasyActionTimes.findIndex(item => item === configData.conf.default.fantasyActionTime)
            // }
            // if (configData.conf.matchTimes && configData.conf.matchTimes.findIndex(item => item === configData.conf.default.matchTime) > 0) {
            //     initFormData.match_time = configData.conf.matchTimes.findIndex(item => item === configData.conf.default.matchTime)
            // }
            // if (configData.conf.multiples && configData.conf.multiples.findIndex(item => item === configData.conf.default.multiple) > 0) {
            //     initFormData.multiple = configData.conf.multiples.findIndex(item => item === configData.conf.default.multiple)
            // }
            // if (configData.conf.potFeeRates && configData.conf.potFeeRates.findIndex(item => item === configData.conf.default.potFeeRate) > 0) {
            //     initFormData.pot_fee_rate = configData.conf.potFeeRates.findIndex(item => item === configData.conf.default.potFeeRate)
            // }
            // if (configData.conf.unloadTimes && configData.conf.unloadTimes.findIndex(item => item === configData.conf.default.unloadTimes) > 0) {
            //     initFormData.unload_times = configData.conf.unloadTimes.findIndex(item => item === configData.conf.default.unloadTimes)
            // }

            this.setState({
                configData: configData,
                formData: initFormData,
            });
        }
    };

    /**
     * 初始化表单数据
     */
    handleInitFormData = (item) => {
        this.formRef.props.form.resetFields();
        // 回显表单数据
        const newFormData = {
            name: item.detail.name,
            game_type: (() => {
                if (item.game_type) {
                    return item.game_type;
                } else {
                    return formData.game_type;
                }
            })(),
            show_profit_type: (() => {
                if (item.detail.pokerExtra.showProfitType) {
                    return item.detail.pokerExtra.showProfitType;
                } else {
                    return formData.show_profit_type;
                }
            })(),
            sub_kind: (() => {
                if (this.state.queryParams.kind === 6) {
                    return item.detail.ofcExtra.gameType;
                } else {
                    return formData.sub_kind;
                }
            })(),
            oper_mod: (() => {
                if (this.state.queryParams.kind === 6) {
                    return item.detail.ofcExtra.operMod;
                } else {
                    return formData.oper_mod;
                }
            })(),
            multiple: (() => {
                if (this.state.queryParams.kind === 6) {
                    let index = this.state.configData.conf.multiples.findIndex(
                        (value) => value === item.detail.ofcExtra.multiple
                    );
                    return index > -1 ? index : formData.multiple;
                } else {
                    return formData.multiple;
                }
            })(),
            blind: (() => {
                if (
                    this.state.queryParams.kind === 1 ||
                    this.state.queryParams.kind === 4 ||
                    this.state.queryParams.kind === 8
                ) {
                    let index = this.state.configData.conf.blinds.findIndex(
                        (value) =>
                            value.sb === item.detail.sb && value.bb === item.detail.bb
                    );
                    return index > -1 ? index : formData.blind;
                } else {
                    return formData.blind;
                }
            })(),
            ante: (() => {
                if (
                    this.state.queryParams.kind === 1 ||
                    this.state.queryParams.kind === 4 ||
                    this.state.queryParams.kind === 8
                ) {
                    let index = this.state.configData.conf.blinds[
                        this.state.configData.conf.blinds.findIndex(
                            (value) =>
                                value.sb === item.detail.sb && value.bb === item.detail.bb
                        )
                    ].antes.findIndex((value) => value === item.detail.ante);
                    return index > -1 ? index : formData.ante;
                } else if (this.state.queryParams.kind === 2) {
                    let index = this.state.configData.conf.shortAntes.findIndex(
                        (value) => value === item.detail.ante
                    );
                    return index > -1 ? index : formData.ante;
                } else {
                    return formData.ante;
                }
            })(),
            ante_hang_value: (() => {
                if (item.detail.pokerExtra.isHang) {
                    let ante_hang_value = item.detail.ante / item.detail.bb;
                    return ante_hang_value >= formData.ante_hang_value ? ante_hang_value : formData.ante_hang_value;
                } else {
                    return formData.ante_hang_value;
                }
            })(),
            carry_range: (() => {
                if (
                    this.state.queryParams.kind === 1 ||
                    this.state.queryParams.kind === 4
                ) {
                    return [
                        this.state.configData.conf.buyins.findIndex(
                            (value) => value === item.detail.minCarry / item.detail.bb
                        ),
                        this.state.configData.conf.buyins.findIndex(
                            (value) => value === item.detail.maxCarry / item.detail.bb
                        ),
                    ];
                } else if (this.state.queryParams.kind === 2) {
                    return [
                        this.state.configData.conf.buyins.findIndex(
                            (value) => value === item.detail.minCarry / item.detail.ante
                        ),
                        this.state.configData.conf.buyins.findIndex(
                            (value) => value === item.detail.maxCarry / item.detail.ante
                        ),
                    ];
                } else if (this.state.queryParams.kind === 6) {
                    return [
                        this.state.configData.conf.buyins.findIndex(
                            (value) =>
                                value === item.detail.minCarry / item.detail.ofcExtra.multiple
                        ),
                        this.state.configData.conf.buyins.findIndex(
                            (value) =>
                                value === item.detail.maxCarry / item.detail.ofcExtra.multiple
                        ),
                    ];
                } else {
                    return [0, 0];
                }
            })(),
            min_carry: (() => {
                if (this.state.queryParams.kind === 8) {
                    let index = this.state.configData.conf.buyins.findIndex(
                        (value) => value === item.detail.minCarry / item.detail.bb
                    );
                    return index > -1 ? index : formData.min_carry;
                } else {
                    return formData.min_carry;
                }
            })(),
            min_play: (() => {
                if (this.state.queryParams.kind === 6) {
                    let index = this.state.configData.conf.minPlays.findIndex(
                        (value) => item.detail.minCarry * value / 100 * this.state.configData.conf.minPlays.length == item.detail.ofcExtra.minEntry
                    );
                    return index > -1 ? index : formData.min_play;
                } else {
                    return formData.min_play;
                }
            })(),
            action_time: (() => {
                if (item.detail.actionTime) {
                    let index = this.state.configData.conf.actionTimes.findIndex(
                        (value) => value === item.detail.actionTime
                    );
                    return index > -1 ? index : formData.action_time;
                } else {
                    return formData.action_time;
                }
            })(),
            match_time: (() => {
                if (item.detail.matchTime) {
                    let index = this.state.configData.conf.matchTimes.findIndex(
                        (value) => value === item.detail.matchTime
                    );
                    return index > -1 ? index : formData.match_time;
                } else {
                    return formData.match_time;
                }
            })(),
            pot_fee_rate: (() => {
                if (item.detail.roomFeeConf.potFeeConf.rate) {
                    let index = this.state.configData.conf.potFeeRates.findIndex(
                        (value) => value === item.detail.roomFeeConf.potFeeConf.rate
                    );
                    return index > -1 ? index : formData.pot_fee_rate;
                } else {
                    return formData.pot_fee_rate;
                }
            })(),
            pot_fee_hand_limit: (() => {
                if (
                    this.state.queryParams.kind === 1 ||
                    this.state.queryParams.kind === 4 ||
                    this.state.queryParams.kind === 8
                ) {
                    let index = this.state.configData.conf.potFeeHandLimitSbs.findIndex(
                        (value) =>
                            value ===
                            item.detail.roomFeeConf.potFeeConf.handLimit / item.detail.sb
                    );
                    return index > -1 ? index : formData.pot_fee_hand_limit;
                } else if (this.state.queryParams.kind === 2) {
                    let index = this.state.configData.conf.potFeeHandLimitAntes.findIndex(
                        (value) =>
                            value ===
                            item.detail.roomFeeConf.potFeeConf.handLimit / item.detail.ante
                    );
                    return index > -1 ? index : formData.pot_fee_hand_limit;
                } else if (this.state.queryParams.kind === 6) {
                    let index = this.state.configData.conf.potFeeHandLimitMulti.findIndex(
                        (value) =>
                            value ===
                            item.detail.roomFeeConf.potFeeConf.handLimit /
                            item.detail.ofcExtra.multiple
                    );
                    return index > -1 ? index : formData.pot_fee_hand_limit;
                } else {
                    return formData.pot_fee_hand_limit;
                }
            })(),
            auto_delay_times: (() => {
                if (
                    this.state.queryParams.kind === 1 ||
                    this.state.queryParams.kind === 2 ||
                    this.state.queryParams.kind === 4 ||
                    this.state.queryParams.kind === 8
                ) {
                    let index = this.state.configData.conf.autoDelayTimes.findIndex(
                        (value) => value === item.detail.pokerExtra.autoDelayTimes
                    );
                    return index > -1 ? index : formData.auto_delay_times;
                } else {
                    return formData.auto_delay_times;
                }
            })(),
            seat_num: (() => {
                if (item.detail.seatNum) {
                    if (
                        this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 4 ||
                        this.state.queryParams.kind === 8
                    ) {
                        let index = this.state.configData.conf.texasUserNums.findIndex(
                            (value) => value === item.detail.seatNum
                        );
                        return index > -1 ? index : formData.seat_num;
                    } else if (this.state.queryParams.kind === 2) {
                        let index = this.state.configData.conf.shortUserNums.findIndex(
                            (value) => value === item.detail.seatNum
                        );
                        return index > -1 ? index : formData.seat_num;
                    } else if (this.state.queryParams.kind === 6) {
                        let index = this.state.configData.conf.ofcUserNums.findIndex(
                            (value) => value === item.detail.seatNum
                        );
                        return index > -1 ? index : formData.seat_num;
                    } else {
                        return formData.seat_num;
                    }
                } else {
                    return formData.seat_num;
                }
            })(),
            is_auto_start_user_num: (() => {
                if (item.detail.autoStartUserNum) {
                    return true;
                } else {
                    return formData.is_auto_start_user_num;
                }
            })(),
            auto_start_user_num: (() => {
                if (item.detail.autoStartUserNum) {
                    if (
                        this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 4 ||
                        this.state.queryParams.kind === 8
                    ) {
                        let index = this.state.configData.conf.texasUserNums.findIndex(
                            (value) => value === item.detail.autoStartUserNum
                        );
                        return index > -1 ? index : formData.auto_start_user_num;
                    } else if (this.state.queryParams.kind === 2) {
                        let index = this.state.configData.conf.shortUserNums.findIndex(
                            (value) => value === item.detail.autoStartUserNum
                        );
                        return index > -1 ? index : formData.auto_start_user_num;
                    } else if (this.state.queryParams.kind === 6) {
                        let index = this.state.configData.conf.ofcUserNums.findIndex(
                            (value) => value === item.detail.autoStartUserNum
                        );
                        return index > -1 ? index : formData.auto_start_user_num;
                    } else {
                        return formData.auto_start_user_num;
                    }
                } else {
                    return formData.auto_start_user_num;
                }
            })(),
            is_unload_times: (() => {
                if (this.state.queryParams.kind === 2 && item.detail.unloadTimes) {
                    return true;
                } else {
                    return formData.is_unload_times;
                }
            })(),
            unload_times: (() => {
                if (this.state.queryParams.kind === 2 && item.detail.unloadTimes) {
                    let index = this.state.configData.conf.unloadTimes.findIndex(
                        (value) => value === item.detail.unloadTimes
                    );
                    return index > -1 ? index : formData.unload_times;
                } else {
                    return formData.unload_times;
                }
            })(),
            is_two_seven_bonus: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.twoSevenBonus
                ) {
                    return true;
                } else {
                    return formData.is_two_seven_bonus;
                }
            })(),
            two_seven_bonus: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.twoSevenBonus
                ) {
                    let index = this.state.configData.conf.twoSevenBonuses.findIndex(
                        (value) => value === item.detail.pokerExtra.twoSevenBonus
                    );
                    return index > -1 ? index : formData.two_seven_bonus;
                } else {
                    return formData.two_seven_bonus;
                }
            })(),
            is_rathole: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 2 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.ratholeMinute
                ) {
                    return true;
                } else {
                    return formData.is_rathole;
                }
            })(),
            rathole_minute: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 2 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.ratholeMinute
                ) {
                    let index = this.state.configData.conf.ratholeMinutes.findIndex(
                        (value) => value === item.detail.pokerExtra.ratholeMinute
                    );
                    return index > -1 ? index : formData.rathole_minute;
                } else {
                    return formData.rathole_minute;
                }
            })(),
            is_call_time: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 2 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.callTimeConf
                ) {
                    return true;
                } else {
                    return formData.is_call_time;
                }
            })(),
            call_time_profit: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 2 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.callTimeConf
                ) {
                    let index = this.state.configData.conf.callTimeProfits.findIndex(
                        (value) => value === item.detail.pokerExtra.callTimeConf.profit
                    );
                    return index > -1 ? index : formData.call_time_profit;
                } else {
                    return formData.call_time_profit;
                }
            })(),
            call_time_lift_type: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 2 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.callTimeConf
                ) {
                    return item.detail.pokerExtra.callTimeConf.liftType;
                } else {
                    return 1;
                }
            })(),
            call_time_lift_hand: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 2 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.callTimeConf &&
                    item.detail.pokerExtra.callTimeConf.liftType === 1
                ) {
                    let index = this.state.configData.conf.callTimeLiftHands.findIndex(
                        (value) => value === item.detail.pokerExtra.callTimeConf.liftHand
                    );
                    return index > -1 ? index : formData.call_time_lift_hand;
                } else {
                    return formData.call_time_lift_hand;
                }
            })(),
            call_time_lift_minute: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 2 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.callTimeConf &&
                    item.detail.pokerExtra.callTimeConf.liftType === 2
                ) {
                    let index = this.state.configData.conf.callTimeLiftMinutes.findIndex(
                        (value) =>
                            value === item.detail.pokerExtra.callTimeConf.liftMinute
                    );
                    return index > -1 ? index : formData.call_time_lift_minute;
                } else {
                    return formData.call_time_lift_minute;
                }
            })(),
            is_boom: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 2 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.boomConf
                ) {
                    return true;
                } else {
                    return formData.is_boom;
                }
            })(),
            boom_range: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 2 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.boomConf
                ) {
                    return [
                        this.state.configData.conf.boomRandBets.findIndex(
                            (value) => value === item.detail.pokerExtra.boomConf.randMin
                        ),
                        this.state.configData.conf.boomRandBets.findIndex(
                            (value) => value === item.detail.pokerExtra.boomConf.randMax
                        ),
                    ];
                } else {
                    return [0, 0];
                }
            })(),
            boom_type: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 2 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.boomConf
                ) {
                    return item.detail.pokerExtra.boomConf.boomType;
                } else {
                    return 1;
                }
            })(),
            boom_hand: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 2 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.boomConf &&
                    item.detail.pokerExtra.boomConf.boomType === 1
                ) {
                    let index = this.state.configData.conf.boomHands.findIndex(
                        (value) => value === item.detail.pokerExtra.boomConf.boomHand
                    );
                    return index > -1 ? index : formData.boom_hand;
                } else {
                    return formData.boom_hand;
                }
            })(),
            boom_minute: (() => {
                if (
                    (this.state.queryParams.kind === 1 ||
                        this.state.queryParams.kind === 2 ||
                        this.state.queryParams.kind === 4) &&
                    item.detail.pokerExtra.boomConf &&
                    item.detail.pokerExtra.boomConf.boomType === 2
                ) {
                    let index = this.state.configData.conf.boomMinutes.findIndex(
                        (value) => value === item.detail.pokerExtra.boomConf.boomMinute
                    );
                    return index > -1 ? index : formData.boom_minute;
                } else {
                    return formData.boom_minute;
                }
            })(),
            is_sit_vpip: (() => {
                if (
                    this.state.queryParams.kind === 1 &&
                    item.detail.pokerExtra.canSitVpip
                ) {
                    return true;
                } else {
                    return formData.is_sit_vpip;
                }
            })(),
            can_sit_vpip: (() => {
                if (this.state.queryParams.kind === 1) {
                    let index = this.state.configData.conf.canSitVpips.findIndex(
                        (value) => value === item.detail.pokerExtra.canSitVpip
                    );
                    return index > -1 ? index : formData.can_sit_vpip;
                } else {
                    return formData.can_sit_vpip;
                }
            })(),
            check_sit_vpip: (() => {
                if (this.state.queryParams.kind === 1) {
                    let index = this.state.configData.conf.checkSitVpips.findIndex(
                        (value) => value === item.detail.pokerExtra.checkSitVpip
                    );
                    return index > -1 ? index : formData.check_sit_vpip;
                } else {
                    return formData.check_sit_vpip;
                }
            })(),
            check_sit_vpip_begin_hand: (() => {
                if (this.state.queryParams.kind === 1) {
                    let index = this.state.configData.conf.checkSitVpipBeginHands.findIndex(
                        (value) => value === item.detail.pokerExtra.checkSitVpipBeginHand
                    );
                    return index > -1 ? index : formData.check_sit_vpip_begin_hand;
                } else {
                    return formData.check_sit_vpip_begin_hand;
                }
            })(),
            is_squid: (() => {
                if (
                    this.state.queryParams.kind === 1 &&
                    item.detail.pokerExtra.squidGameConf
                ) {
                    return true;
                } else {
                    return formData.is_squid;
                }
            })(),
            squid_mode: (() => {
                if (
                    this.state.queryParams.kind === 1 &&
                    item.detail.pokerExtra.squidGameConf
                ) {
                    return item.detail.pokerExtra.squidGameConf.mode;
                } else {
                    return 1;
                }
            })(),
            squid_bb: (() => {
                if (
                    this.state.queryParams.kind === 1 &&
                    item.detail.pokerExtra.squidGameConf
                ) {
                    let index = this.state.configData.conf.squidBBs.findIndex(
                        (value) => value === item.detail.pokerExtra.squidGameConf.bb
                    );
                    return index > -1 ? index : formData.squid_bb;
                } else {
                    return formData.squid_bb;
                }
            })(),
            is_sushi: (() => {
                if (
                    this.state.queryParams.kind === 1 &&
                    item.detail.pokerExtra.sushiModeConf
                ) {
                    return true;
                } else {
                    return formData.is_sushi;
                }
            })(),
            sushi_base_ante: (() => {
                if (
                    this.state.queryParams.kind === 1 &&
                    item.detail.pokerExtra.sushiModeConf
                ) {
                    let index = this.state.configData.conf.sushiBaseAnte.findIndex(
                        (value) => value === item.detail.pokerExtra.sushiModeConf.baseAnte
                    );
                    return index > -1 ? index : formData.sushi_base_ante;
                } else {
                    return formData.sushi_base_ante;
                }
            })(),
            sushi_seat_ante: (() => {
                if (
                    this.state.queryParams.kind === 1 &&
                    item.detail.pokerExtra.sushiModeConf
                ) {
                    let index = this.state.configData.conf.sushiSeatAnte.findIndex(
                        (value) => value === item.detail.pokerExtra.sushiModeConf.seatAnte
                    );
                    return index > -1 ? index : formData.sushi_seat_ante;
                } else {
                    return formData.sushi_seat_ante;
                }
            })(),
            is_hang: item.detail.pokerExtra.isHang,
            magic_card: item.detail.ofcExtra.magicCard,
            is_show_all_hands: item.detail.showAllHands,
            random_seat: item.detail.pokerExtra.randomSeat,
            is_insurance: item.detail.insurance,
            show_cowboy: item.detail.pokerExtra.showCowboy,
            force_blind: item.detail.forceBlind,
            is_straddle: item.detail.straddle,
            is_friend_limit: item.detail.friendLimit,
            is_ip_gps_limit: item.detail.ipLimit,
            is_close_chat: item.detail.closeChat,
            block_simulator: item.detail.blockSimulator,
            // auto_create_match: item.detail.autoCreateMatch,
        };
        this.setState({
            formData: newFormData,
        });
    };

    /**
     * 添加
     */
    handleAdd = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                // nlh校验
                if ([1].includes(this.state.queryParams.kind)) {
                    // 夯场模式和寿司游戏不可同时开启
                    if (values.is_hang && values.is_sushi) {
                        return message.error(this.props.language["superAndSushiDisabledTips"])
                    }
                }

                // plo校验
                if ([4].includes(this.state.queryParams.kind)) {
                    // plo6人数必须小于8人
                    if (values.game_type === 7 && this.state.configData.conf.texasUserNums[values.seat_num] > 7) {
                        return message.error(this.props.language["seatNumSetMessage"])
                    }
                    // plo6自动开始人数必须小于8人
                    if (values.game_type === 7 && this.state.configData.conf.texasUserNums[values.auto_start_user_num] > 7) {
                        return message.error(this.props.language["autoStartUserNumMessage"])
                    }
                }

                // ofc校验
                if ([6].includes(this.state.queryParams.kind)) {
                    // 带入范围不能一致
                    if (values.carry_range[0] === values.carry_range[1]) {
                        return message.error(this.props.language["broughtRangeCannotConsistentMessage"])
                    }
                }

                const params = {
                    kind: this.state.queryParams.kind,
                    name: values.name,
                    game_type: values.game_type,
                    show_profit_type: values.show_profit_type,
                    sub_kind: (() => {
                        if (this.state.queryParams.kind === 6) {
                            return values.sub_kind;
                        } else {
                            return undefined;
                        }
                    })(),
                    oper_mod: (() => {
                        if (this.state.queryParams.kind === 6) {
                            return values.oper_mod;
                        } else {
                            return undefined;
                        }
                    })(),
                    multiple: (() => {
                        if (this.state.queryParams.kind === 6) {
                            return this.state.configData.conf.multiples[values.multiple];
                        } else {
                            return undefined;
                        }
                    })(),
                    sb: (() => {
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8
                        ) {
                            return this.state.configData.conf.blinds[values.blind].sb;
                        } else {
                            return undefined;
                        }
                    })(),
                    bb: (() => {
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8
                        ) {
                            return this.state.configData.conf.blinds[values.blind].bb;
                        } else {
                            return undefined;
                        }
                    })(),
                    ante: (() => {
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8
                        ) {
                            if (this.state.queryParams.kind === 1 && values.is_hang) {
                                return values.ante_hang_value * this.state.configData.conf.blinds[values.blind].bb;
                            } else {
                                return this.state.configData.conf.blinds[values.blind].antes[
                                    values.ante
                                ];
                            }
                        } else if (this.state.queryParams.kind === 2) {
                            return this.state.configData.conf.shortAntes[values.ante];
                        } else {
                            return undefined;
                        }
                    })(),
                    min_carry: (() => {
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 4
                        ) {
                            return (
                                this.state.configData.conf.buyins[values.carry_range[0]] *
                                this.state.configData.conf.blinds[values.blind].bb
                            );
                        } else if (this.state.queryParams.kind === 2) {
                            return (
                                this.state.configData.conf.buyins[values.carry_range[0]] *
                                this.state.configData.conf.shortAntes[values.ante]
                            );
                        } else if (this.state.queryParams.kind === 6) {
                            return (
                                this.state.configData.conf.buyins[values.carry_range[0]] *
                                this.state.configData.conf.multiples[values.multiple]
                            );
                        } else if (this.state.queryParams.kind === 8) {
                            return (
                                this.state.configData.conf.buyins[values.min_carry] *
                                this.state.configData.conf.blinds[values.blind].bb
                            );
                        } else {
                            return undefined;
                        }
                    })(),
                    max_carry: (() => {
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 4
                        ) {
                            return (
                                this.state.configData.conf.buyins[values.carry_range[1]] *
                                this.state.configData.conf.blinds[values.blind].bb
                            );
                        } else if (this.state.queryParams.kind === 2) {
                            return (
                                this.state.configData.conf.buyins[values.carry_range[1]] *
                                this.state.configData.conf.shortAntes[values.ante]
                            );
                        } else if (this.state.queryParams.kind === 6) {
                            return (
                                this.state.configData.conf.buyins[values.carry_range[1]] *
                                this.state.configData.conf.multiples[values.multiple]
                            );
                        } else if (this.state.queryParams.kind === 8) {
                            return (
                                this.state.configData.conf.buyins[values.min_carry] *
                                this.state.configData.conf.blinds[values.blind].bb
                            );
                        } else {
                            return undefined;
                        }
                    })(),
                    min_play: (() => {
                        if (this.state.queryParams.kind === 6) {
                            return (
                                this.state.configData.conf.buyins[values.carry_range[0]] *
                                this.state.configData.conf.multiples[values.multiple] *
                                this.state.configData.conf.minPlays[values.min_play] /
                                this.state.configData.conf.minPlays.length
                            );
                        } else {
                            return undefined;
                        }
                    })(),
                    action_time: (() => {
                        return this.state.configData.conf.actionTimes[values.action_time];
                    })(),
                    fantasy_action_time: (() => {
                        if (this.state.queryParams.kind === 6) {
                            return this.state.configData.conf.fantasyActionTimes[
                                values.action_time
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    match_time: (() => {
                        return this.state.configData.conf.matchTimes[values.match_time];
                    })(),
                    pot_fee_rate: (() => {
                        return this.state.configData.conf.potFeeRates[values.pot_fee_rate];
                    })(),
                    pot_fee_hand_limit: (() => {
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8
                        ) {
                            return (
                                this.state.configData.conf.potFeeHandLimitSbs[
                                values.pot_fee_hand_limit
                                ] * this.state.configData.conf.blinds[values.blind].sb
                            );
                        } else if (this.state.queryParams.kind === 2) {
                            return (
                                this.state.configData.conf.potFeeHandLimitAntes[
                                values.pot_fee_hand_limit
                                ] * this.state.configData.conf.shortAntes[values.ante]
                            );
                        } else if (this.state.queryParams.kind === 6) {
                            return (
                                this.state.configData.conf.potFeeHandLimitMulti[
                                values.pot_fee_hand_limit
                                ] * this.state.configData.conf.multiples[values.multiple]
                            );
                        } else {
                            return undefined;
                        }
                    })(),
                    auto_delay_times: (() => {
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8
                        ) {
                            return this.state.configData.conf.autoDelayTimes[
                                values.auto_delay_times
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    seat_num: (() => {
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8
                        ) {
                            return this.state.configData.conf.texasUserNums[values.seat_num];
                        } else if (this.state.queryParams.kind === 2) {
                            return this.state.configData.conf.shortUserNums[values.seat_num];
                        } else if (this.state.queryParams.kind === 6) {
                            return this.state.configData.conf.ofcUserNums[values.seat_num];
                        } else {
                            return undefined;
                        }
                    })(),
                    auto_start_user_num: (() => {
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8
                        ) {
                            return this.state.configData.conf.texasUserNums[values.auto_start_user_num];
                        } else if (this.state.queryParams.kind === 2) {
                            return this.state.configData.conf.shortUserNums[values.auto_start_user_num];
                        } else if (this.state.queryParams.kind === 6) {
                            return this.state.configData.conf.ofcUserNums[values.auto_start_user_num];
                        } else {
                            return undefined;
                        }
                    })(),
                    unload_times: (() => {
                        if (!values.is_unload_times) return undefined;
                        if (this.state.queryParams.kind === 2) {
                            return this.state.configData.conf.unloadTimes[
                                values.unload_times
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    two_seven_bonus: (() => {
                        if (!values.is_two_seven_bonus) return undefined;
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 4
                        ) {
                            return this.state.configData.conf.twoSevenBonuses[
                                values.two_seven_bonus
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    rathole_minute: (() => {
                        if (!values.is_rathole) return undefined;
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4
                        ) {
                            return this.state.configData.conf.ratholeMinutes[
                                values.rathole_minute
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    call_time_profit: (() => {
                        if (!values.is_call_time) return undefined;
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4
                        ) {
                            return this.state.configData.conf.callTimeProfits[
                                values.call_time_profit
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    call_time_lift_type: (() => {
                        if (!values.is_call_time) return undefined;
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4
                        ) {
                            return values.call_time_lift_type;
                        } else {
                            return undefined;
                        }
                    })(),
                    call_time_lift_hand: (() => {
                        if (!values.is_call_time) return undefined;
                        if (
                            (this.state.queryParams.kind === 1 ||
                                this.state.queryParams.kind === 2 ||
                                this.state.queryParams.kind === 4) &&
                            values.call_time_lift_type === 1
                        ) {
                            return this.state.configData.conf.callTimeLiftHands[
                                values.call_time_lift_hand
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    call_time_lift_minute: (() => {
                        if (!values.is_call_time) return undefined;
                        if (
                            (this.state.queryParams.kind === 1 ||
                                this.state.queryParams.kind === 2 ||
                                this.state.queryParams.kind === 4) &&
                            values.call_time_lift_type === 2
                        ) {
                            return this.state.configData.conf.callTimeLiftMinutes[
                                values.call_time_lift_minute
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    boom_rand_min: (() => {
                        if (!values.is_boom) return undefined;
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4
                        ) {
                            return this.state.configData.conf.boomRandBets[
                                values.boom_range[0]
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    boom_rand_max: (() => {
                        if (!values.is_boom) return undefined;
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4
                        ) {
                            return this.state.configData.conf.boomRandBets[
                                values.boom_range[1]
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    boom_type: (() => {
                        if (!values.is_boom) return undefined;
                        if (
                            this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4
                        ) {
                            return values.boom_type;
                        } else {
                            return undefined;
                        }
                    })(),
                    boom_hand: (() => {
                        if (!values.is_boom) return undefined;
                        if (
                            (this.state.queryParams.kind === 1 ||
                                this.state.queryParams.kind === 2 ||
                                this.state.queryParams.kind === 4) &&
                            values.boom_type === 1
                        ) {
                            return this.state.configData.conf.boomHands[values.boom_hand];
                        } else {
                            return undefined;
                        }
                    })(),
                    boom_minute: (() => {
                        if (!values.is_boom) return undefined;
                        if (
                            (this.state.queryParams.kind === 1 ||
                                this.state.queryParams.kind === 2 ||
                                this.state.queryParams.kind === 4) &&
                            values.boom_type === 2
                        ) {
                            return this.state.configData.conf.boomMinutes[values.boom_minute];
                        } else {
                            return undefined;
                        }
                    })(),
                    can_sit_vpip: (() => {
                        if (!values.is_sit_vpip) return undefined;
                        if (this.state.queryParams.kind === 1) {
                            return this.state.configData.conf.canSitVpips[
                                values.can_sit_vpip
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    check_sit_vpip: (() => {
                        if (!values.is_sit_vpip) return undefined;
                        if (this.state.queryParams.kind === 1) {
                            return this.state.configData.conf.checkSitVpips[
                                values.check_sit_vpip
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    check_sit_vpip_begin_hand: (() => {
                        if (!values.is_sit_vpip) return undefined;
                        if (this.state.queryParams.kind === 1) {
                            return this.state.configData.conf.checkSitVpipBeginHands[
                                values.check_sit_vpip_begin_hand
                            ];
                        } else {
                            return undefined;
                        }
                    })(),
                    squid_mode: (() => {
                        if (!values.is_squid) return undefined;
                        if (this.state.queryParams.kind === 1) {
                            return values.squid_mode;
                        } else {
                            return undefined;
                        }
                    })(),
                    squid_bb: (() => {
                        if (!values.is_squid) return undefined;
                        if (this.state.queryParams.kind === 1) {
                            return this.state.configData.conf.squidBBs[values.squid_bb];
                        } else {
                            return undefined;
                        }
                    })(),
                    sushi_base_ante: (() => {
                        if (!values.is_sushi) return undefined;
                        if (this.state.queryParams.kind === 1) {
                            return this.state.configData.conf.sushiBaseAnte[values.sushi_base_ante];
                        } else {
                            return undefined;
                        }
                    })(),
                    sushi_seat_ante: (() => {
                        if (!values.is_sushi) return undefined;
                        if (this.state.queryParams.kind === 1) {
                            return this.state.configData.conf.sushiSeatAnte[values.sushi_seat_ante];
                        } else {
                            return undefined;
                        }
                    })(),
                    magic_card: values.magic_card,
                    is_hang: values.is_hang,
                    is_show_all_hands: values.is_show_all_hands,
                    is_insurance: values.is_insurance,
                    show_cowboy: values.show_cowboy,
                    force_blind: values.force_blind,
                    is_straddle: values.is_straddle,
                    is_friend_limit: values.is_friend_limit,
                    is_ip_limit: values.is_ip_gps_limit,
                    is_gps_limit: values.is_ip_gps_limit,
                    is_close_chat: values.is_close_chat,
                    random_seat: values.random_seat,
                    block_simulator: values.block_simulator,
                    // auto_create_match: values.auto_create_match,
                    // coin_type: 1,
                    // result_fee_rate: 300,
                    // is_buy_in_auth: false,
                    // IsShowAllHands: true,
                };

                axios.post("/v1/api/create_match_conf", params).then((res) => {
                    if (res.code === 1) {
                        message.success(this.props.language["addSuccessMessage"]);
                        this.handleClose("addConfig");
                        this.fetchData();
                    }
                });
            }
        });
    };

    /**
     * 导入赛事配置
     */
    handleImportMatchConfig = () => {
        this.importFormRef.props.form.validateFields((err, values) => {
            if (!err) {
                const formData = this.state.configList.find(
                    (item) => item.id === values.id
                );
                this.handleInitFormData(formData);
                message.success(this.props.language["importSuccessMessage"]);
                this.handleClose("importConfig");
            }
        });
    };

    /**
     * 导入多个赛事配置
     */
    handleImportAllMatchConfig = () => {
        this.importAllFormRef.props.form.validateFields((err, values) => {
            if (!err) {
                axios
                    .post("/v1/api/create_match_conf_import", {
                        uri: values.uri,
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["importSuccessMessage"]);
                            this.handleClose("importAllConfig");
                            this.fetchData()
                        }
                    });
            }
        });
    };

    /**
     * 上传配置
     */
    handleUploadConfig = ({ file }) => {
        this.setState({ uploadConfigLoading: true })
        myUploadAxios.post('/v1/api/upload/s3', { path: 'cms/union/match', file: file }).then((res) => {
            if (res.code === 200) {
                this.setState({ uploadFile: file })
                this.importAllFormRef.props.form.setFieldsValue({ uri: res.data })
            }
            this.setState({ uploadConfigLoading: false })
        })
    };

    /**
     * 删除配置
     */
    handelDelete = (id) => {
        Modal.confirm({
            title: this.props.language["hint"],
            content: this.props.language["deleteConfirm"],
            onOk: () => {
                axios
                    .delete("/v1/api/create_match_conf", {
                        data: {
                            conf_id: id,
                            kind: this.state.queryParams.kind,
                        },
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["deleteSuccessMessage"]);
                            this.fetchData();
                        }
                    });
            },
        });
    };

    /**
     * 删除所有配置
     */
    handelDeleteAll = () => {
        Modal.confirm({
            title: this.props.language["hint"],
            content: this.props.language["deleteAllConfirm"],
            onOk: () => {
                axios
                    .post("/v1/api/del_all_match_conf")
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["deleteSuccessMessage"]);
                            this.fetchData();
                        }
                    });
            },
        });
    };

    /**
     * 显示弹窗
     */
    handleShow = async (type) => {
        const kind = this.state.kindList.find(
            (item) => item.value === this.state.queryParams.kind
        );
        if (type === "addConfig") {
            // 添加配置
            await this.fetchConfigData();
            this.setState({
                show: true,
                title: this.props.getLanguage("addConfig", kind.label),
                importTitle: this.props.getLanguage("importConfig", kind.label),
            });
        } else if (type === "importConfig") {
            // 导入配置
            this.setState({
                showImport: true,
                configLoading: true,
                importTitle: this.props.getLanguage("importConfig", kind.label),
            })
            this.fetchConfigList()
        } else if (type === "importAllConfig") {
            // 导入多个配置
            this.setState({
                showImportAll: true,
                importAllTitle: this.props.language["importConfigFile"]
            });
        }
    };

    /**
     * 关闭弹窗
     */
    handleClose = (type) => {
        if (type === "addConfig") {
            this.formRef.props.form.resetFields();
            this.setState({ show: false, formData: { ...formData } });
        } else if (type === "importConfig") {
            this.importFormRef.props.form.resetFields();
            this.setState({ showImport: false });
        } else if (type === "importAllConfig") {
            this.importAllFormRef.props.form.resetFields();
            this.setState({ showImportAll: false });
        }
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState(
            { queryParams: { ...this.state.queryParams, page: 1, [key]: value } },
            () => {
                this.fetchData();
            }
        );
    };

    /**
     * 导出数据
     */
    handleExport = () => {
        this.setState({ exportLoading: true });
        axios
            .get("/v1/api/create_match_conf_export", {
                params: {
                    kind: this.state.queryParams.kind,
                },
            })
            .then((res) => {
                this.setState({ exportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 导出所有数据
     */
    handleExportAll = () => {
        this.setState({ exportAllLoading: true });
        axios
            .get("/v1/api/create_match_conf_export_all")
            .then((res) => {
                this.setState({ exportAllLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 改变和夯场相关的组件后回调
     */
    handleChangeHang = (type, value) => {
        if (this.state.configData.kind === 1) {
            setTimeout(() => {
                let newValues = this.formRef.props.form.getFieldsValue()

                let bb = this.state.configData.conf.blinds[newValues.blind].bb
                let carry_range = [this.state.configData.conf.buyins.findIndex(item => item * bb === newValues.ante_hang_value * bb * 10), this.state.configData.conf.buyins.findIndex(item => item * bb === newValues.ante_hang_value * bb * 10)]

                let ante_value = this.state.configData.conf.blinds[newValues.blind].antes[newValues.ante];
                let ante_hang_value = ante_value / bb
                let carry_range_min_value = this.state.configData.conf.buyins[newValues.carry_range[0]] * this.state.configData.conf.blinds[newValues.blind].bb
                let carry_range_max_value = this.state.configData.conf.buyins[newValues.carry_range[1]] * this.state.configData.conf.blinds[newValues.blind].bb

                if (type === 'blind') {
                    // 级别范围
                    this.formRef.props.form.setFieldsValue({
                        is_hang: false,
                        ante: this.state.formData.ante,
                        carry_range: this.state.formData.carry_range,
                    })
                } else if (type === 'is_hang') {
                    // 夯场模式
                    this.formRef.props.form.setFieldsValue({
                        carry_range,
                    })
                } else if (type === 'ante_hange_value') {
                    // 夯场前注
                    this.formRef.props.form.setFieldsValue({
                        carry_range,
                    })
                } else if (type === 'ante' || type === 'carry_range') {
                    // 前注，带入范围
                    if (ante_value / carry_range_min_value >= 0.1 && carry_range_min_value === carry_range_max_value) {
                        // 激活夯场模式
                        this.formRef.props.form.setFieldsValue({ is_hang: true })
                        this.formRef.props.form.setFieldsValue({ ante_hang_value })
                    } else {
                        // 关闭夯场模式
                        this.formRef.props.form.setFieldsValue({
                            is_hang: false,
                        })
                    }
                }
            })
        }
    }

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    kind: 1,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["gameTypePlaceholder"]}
                        value={this.state.queryParams.kind}
                        onChange={(value) => this.handleSetQueryParamsData("kind", value)}
                    >
                        {this.state.kindList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow("addConfig")}
                    >
                        {this.props.getLanguage("addConfig", this.state.kindList.find((item) => item.value === this.state.queryParams.kind) ? this.state.kindList.find((item) => item.value === this.state.queryParams.kind).label : '')}
                    </Button>
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow("importAllConfig")}
                    >
                        {this.props.language["importConfigFile"]}
                    </Button>
                    <Button
                        type="danger"
                        ghost
                        onClick={() => this.handelDeleteAll()}
                    >
                        {this.props.language["deleteAllConfig"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={this.handleExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportAllLoading}
                        onClick={this.handleExportAll}
                    >
                        {this.props.language["exportAllExcel"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["configId"]}
                            dataIndex="id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleName"]}
                            dataIndex="default_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameType"]}
                            dataIndex=""
                            render={(item) =>
                                item.kind === 4 ?
                                    this.state.subKindList.find(
                                        (item2) => item2.value === item.detail.pokerExtra.gameType
                                    )
                                        ? this.state.subKindList.find(
                                            (item2) => item2.value === item.detail.pokerExtra.gameType
                                        ).label
                                        : ""
                                    :
                                    this.state.kindList.find(
                                        (item2) => item2.value === item.kind
                                    )
                                        ? this.state.kindList.find(
                                            (item2) => item2.value === item.kind
                                        ).label
                                        : ""
                            }
                        />
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["realTimeRecord"]}
                                    dataIndex=""
                                    render={(item) =>
                                        this.state.profitTypeList.find(
                                            (item2) =>
                                                item2.value === item.detail.pokerExtra.showProfitType
                                        ) ?
                                            this.state.profitTypeList.find(
                                                (item2) =>
                                                    item2.value === item.detail.pokerExtra.showProfitType
                                            ).label
                                            : ''
                                    }
                                />
                            )}
                        {this.state.queryParams.kind === 6 && (
                            <Table.Column
                                align="center"
                                title={this.props.language["gameMode"]}
                                dataIndex=""
                                render={(item) =>
                                    this.state.gameTypeList.find(
                                        (item2) => item2.value === item.detail.ofcExtra.gameType
                                    ) ?
                                        this.state.gameTypeList.find(
                                            (item2) => item2.value === item.detail.ofcExtra.gameType
                                        ).label
                                        : ''
                                }
                            />
                        )}
                        {this.state.queryParams.kind === 6 && (
                            <Table.Column
                                align="center"
                                title={this.props.language["operationOrder"]}
                                dataIndex=""
                                render={(item) =>
                                    this.state.operModList.find(
                                        (item2) => item2.value === item.detail.ofcExtra.operMod
                                    ) ?
                                        this.state.operModList.find(
                                            (item2) => item2.value === item.detail.ofcExtra.operMod
                                        ).label
                                        : ''
                                }
                            />
                        )}
                        {this.state.queryParams.kind === 6 && (
                            <Table.Column
                                align="center"
                                title={this.props.language["multiple"]}
                                dataIndex=""
                                render={(item) =>
                                    item.detail.ofcExtra.multiple / 100 +
                                    this.props.language["double"]
                                }
                            />
                        )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["levelRange"]}
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.sb / 100 + "/" + item.detail.bb / 100
                                    }
                                />
                            )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["foreword"]}
                                    dataIndex=""
                                    render={(item) => item.detail.ante / 100}
                                />
                            )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 6) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["bringRange"]}
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.minCarry / 100 + "/" + item.detail.maxCarry / 100
                                    }
                                />
                            )}
                        {this.state.queryParams.kind === 8 && (
                            <Table.Column
                                align="center"
                                title={this.props.language["minSubstitution"]}
                                dataIndex=""
                                render={(item) => item.detail.minCarry / 100}
                            />
                        )}
                        {this.state.queryParams.kind === 6 && (
                            <Table.Column
                                align="center"
                                title={this.props.language["minEntryPoint"]}
                                dataIndex=""
                                render={(item) => item.detail.ofcExtra.minEntry / 100}
                            />
                        )}
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFee"]}
                            dataIndex=""
                            render={(item) =>
                                item.detail.roomFeeConf.potFeeConf.rate / 100 + "%"
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFeeCap"]}
                            dataIndex=""
                            render={(item) =>
                                item.detail.roomFeeConf.potFeeConf.handLimit !== 0
                                    ? item.detail.roomFeeConf.potFeeConf.handLimit + "BB"
                                    : this.props.language["unlimited"]
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["thinkTime"]}
                            dataIndex=""
                            render={(item) =>
                                item.detail.actionTime + this.props.language["second"]
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex=""
                            render={(item) =>
                                item.detail.matchTime / 3600 + this.props.language["hour"]
                            }
                        />
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 5) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["delayTime"]}
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.pokerExtra.autoDelayTimes +
                                        this.props.language["count"]
                                    }
                                />
                            )}
                        <Table.Column
                            align="center"
                            title={this.props.language["peopleNumber"]}
                            dataIndex=""
                            render={(item) =>
                                item.detail.seatNum + this.props.language["person"]
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["autoStartPeople"]}
                            dataIndex=""
                            render={(item) =>
                                item.detail.autoStartUserNum
                                    ? item.detail.autoStartUserNum + this.props.language["person"]
                                    : this.props.language["no"]
                            }
                        />
                        {this.state.queryParams.kind === 2 && (
                            <Table.Column
                                align="center"
                                title={this.props.language["autoUnloadCode"]}
                                dataIndex=""
                                render={(item) =>
                                    item.detail.unloadTimes
                                        ? item.detail.unloadTimes / 100
                                        : this.props.language["no"]
                                }
                            />
                        )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 4) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["colorPool"]}
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.pokerExtra.twoSevenBonus
                                            ? item.detail.pokerExtra.twoSevenBonus + "BB"
                                            : this.props.language["no"]
                                    }
                                />
                            )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4) && (
                                <Table.Column
                                    align="center"
                                    title="Rathole"
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.pokerExtra.ratholeMinute
                                            ? item.detail.pokerExtra.ratholeMinute +
                                            this.props.language["minute"]
                                            : this.props.language["no"]
                                    }
                                />
                            )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4) && (
                                <Table.Column
                                    align="center"
                                    title="CallTime"
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.pokerExtra.callTimeConf
                                            ? `${item.detail.pokerExtra.callTimeConf.profit}BB(${item.detail.pokerExtra.callTimeConf.liftType === 1
                                                ? item.detail.pokerExtra.callTimeConf.liftHand +
                                                this.props.language["hand"]
                                                : item.detail.pokerExtra.callTimeConf.liftMinute +
                                                this.props.language["minute"]
                                            })`
                                            : this.props.language["no"]
                                    }
                                />
                            )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["bombMode"]}
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.pokerExtra.boomConf
                                            ? `${item.detail.pokerExtra.boomConf.randMin}BB/${item.detail.pokerExtra.boomConf.randMax
                                            }BB(${item.detail.pokerExtra.boomConf.boomType === 1
                                                ? item.detail.pokerExtra.boomConf.boomHand +
                                                this.props.language["hand"]
                                                : item.detail.pokerExtra.boomConf.boomMinute +
                                                this.props.language["minute"]
                                            })`
                                            : this.props.language["no"]
                                    }
                                />
                            )}
                        {this.state.queryParams.kind === 1 && (
                            <Table.Column
                                align="center"
                                title={this.props.language["entryPoolStandard"]}
                                dataIndex=""
                                render={(item) =>
                                    item.detail.pokerExtra.checkSitVpipBeginHand ? (
                                        <>
                                            <p>
                                                {this.props.language["sitEntryPoolRate"]}：
                                                {item.detail.pokerExtra.canSitVpip / 100}%
                                            </p>
                                            <p>
                                                {this.props.language["currentEntryPoolStandard"]}：
                                                {item.detail.pokerExtra.checkSitVpip / 100}%
                                            </p>
                                            <p>
                                                {this.props.language["detectionHandNumber"]}：
                                                {item.detail.pokerExtra.checkSitVpipBeginHand}
                                                {this.props.language["hand"]}
                                            </p>
                                        </>
                                    ) : (
                                        this.props.language["no"]
                                    )
                                }
                            />
                        )}
                        {this.state.queryParams.kind === 1 && (
                            <Table.Column
                                align="center"
                                title={this.props.language["squidGame"]}
                                dataIndex=""
                                render={(item) =>
                                    item.detail.pokerExtra.squidGameConf ? (
                                        <>
                                            <p>
                                                {this.state.squidTypeList.find(
                                                    (item2) =>
                                                        item2.value ===
                                                        item.detail.pokerExtra.squidGameConf.mode
                                                ) ?
                                                    this.state.squidTypeList.find(
                                                        (item2) =>
                                                            item2.value ===
                                                            item.detail.pokerExtra.squidGameConf.mode
                                                    ).label : ''}
                                                ({item.detail.pokerExtra.squidGameConf.bb / 2}BB)
                                            </p>
                                        </>
                                    ) : (
                                        this.props.language["no"]
                                    )
                                }
                            />
                        )}
                        {this.state.queryParams.kind === 1 && (
                            <Table.Column
                                align="center"
                                title={this.props.language["sushiGame"]}
                                dataIndex=""
                                render={(item) =>
                                    item.detail.pokerExtra.sushiModeConf ? (
                                        <>
                                            <p>
                                                {item.detail.pokerExtra.sushiModeConf.baseAnte}BB
                                                /
                                                {item.detail.pokerExtra.sushiModeConf.seatAnte}BB
                                            </p>
                                        </>
                                    ) : (
                                        this.props.language["no"]
                                    )
                                }
                            />
                        )}
                        {this.state.queryParams.kind === 1 && (
                            <Table.Column
                                align="center"
                                title={this.props.language["hangMode"]}
                                dataIndex=""
                                render={(item) =>
                                    item.detail.pokerExtra.isHang === true
                                        ? this.props.language["yes"]
                                        : this.props.language["no"]
                                }
                            />
                        )}
                        {this.state.queryParams.kind === 6 && (
                            <Table.Column
                                align="center"
                                title={this.props.language["lame"]}
                                dataIndex=""
                                render={(item) =>
                                    item.detail.ofcExtra.magicCard === true
                                        ? this.props.language["yes"]
                                        : this.props.language["no"]
                                }
                            />
                        )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["insuranceMode"]}
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.insurance === true
                                            ? this.props.language["yes"]
                                            : this.props.language["no"]
                                    }
                                />
                            )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["isRoomCowboy"]}
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.pokerExtra.showCowboy === true
                                            ? this.props.language["yes"]
                                            : this.props.language["no"]
                                    }
                                />
                            )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 8 ||
                            this.state.queryParams.kind === 4) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["blind"]}
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.forceBlind === true
                                            ? this.props.language["yes"]
                                            : this.props.language["no"]
                                    }
                                />
                            )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 4) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["straddle"]}
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.straddle === true
                                            ? this.props.language["yes"]
                                            : this.props.language["no"]
                                    }
                                />
                            )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["showHands"]}
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.showAllHands === true
                                            ? this.props.language["yes"]
                                            : this.props.language["no"]
                                    }
                                />
                            )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["openCard"]}
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.friendLimit === true
                                            ? this.props.language["yes"]
                                            : this.props.language["no"]
                                    }
                                />
                            )}
                        {(this.state.queryParams.kind === 1 ||
                            this.state.queryParams.kind === 2 ||
                            this.state.queryParams.kind === 4 ||
                            this.state.queryParams.kind === 8) && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["randomSeat"]}
                                    dataIndex=""
                                    render={(item) =>
                                        item.detail.pokerExtra.randomSeat === false
                                            ? this.props.language["no"]
                                            : this.props.language["yes"]
                                    }
                                />
                            )}
                        <Table.Column
                            align="center"
                            title={this.props.language["ipAndGpsLimit"]}
                            dataIndex=""
                            render={(item) =>
                                item.detail.ipLimit === true && item.detail.gpsLimit === true
                                    ? this.props.language["yes"]
                                    : this.props.language["no"]
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["closeChat"]}
                            dataIndex=""
                            render={(item) =>
                                item.detail.closeChat === true
                                    ? this.props.language["yes"]
                                    : this.props.language["no"]
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["disableSimulator"]}
                            dataIndex=""
                            render={(item) =>
                                item.detail.blockSimulator === true
                                    ? this.props.language["yes"]
                                    : this.props.language["no"]
                            }
                        />
                        {/* <Table.Column align="center" title="自动重建房间" dataIndex="" render={(item) => item.detail.autoCreateMatch === true ? '是' : '否'} /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={120}
                            render={(item) => (
                                <Button
                                    type="danger"
                                    ghost
                                    onClick={() => this.handelDelete(item.id)}
                                >
                                    {this.props.language["delete"]}
                                </Button>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单内容 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    title={this.state.title}
                    importTitle={this.state.importTitle}
                    configData={this.state.configData}
                    formData={this.state.formData}
                    handCardNumberList={this.state.handCardNumberList}
                    profitTypeList={this.state.profitTypeList}
                    squidTypeList={this.state.squidTypeList}
                    gameTypeList={this.state.gameTypeList}
                    operModList={this.state.operModList}
                    typeList={this.state.typeList}
                    onOk={this.handleAdd}
                    handleShow={this.handleShow}
                    onCancel={this.handleClose}
                    handleChangeHang={this.handleChangeHang}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />

                {/* 导入配置表单弹窗 */}
                <ImprotFormModal
                    {...this.props}
                    loading={this.state.configLoading}
                    visible={this.state.showImport}
                    title={this.state.importTitle}
                    kindList={this.state.kindList}
                    queryParams={this.state.queryParams}
                    configList={this.state.configList}
                    onOk={this.handleImportMatchConfig}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(importFormRef) =>
                        (this.importFormRef = importFormRef)
                    }
                />

                {/* 导入多个配置弹窗 */}
                <ImprotAllFormModal
                    {...this.props}
                    visible={this.state.showImportAll}
                    title={this.state.importAllTitle}
                    uploadConfigLoading={this.state.uploadConfigLoading}
                    importAllformData={this.state.importAllformData}
                    uploadFile={this.state.uploadFile}
                    handleUploadConfig={this.handleUploadConfig}
                    onOk={this.handleImportAllMatchConfig}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(importAllFormRef) => (this.importAllFormRef = importAllFormRef)}
                />
            </div>
        );
    }
}

/**
 * 表单内容
 */
const FormModal = Form.create({ name: "form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form;

            return (
                <Modal
                    maskClosable={false}
                    width={700}
                    title={
                        <Row type="flex" align="middle" justify="space-between">
                            <div>
                                <span>{this.props.title}</span>
                                {this.props.visible && (
                                    <span style={{ color: "#ff4d4f", display: isMobileDevice() ? 'flex' : 'inline-block' }}>
                                        （
                                        {(getFieldValue("is_hang") !== undefined ? getFieldValue("is_hang") : this.props.formData.is_hang) ?
                                            <span>
                                                <span>
                                                    {this.props.language["everyHoursConsumeDiamond"]}：
                                                </span>
                                                <span>
                                                    {
                                                        this.props.configData.conf.hangCost[getFieldValue("blind")]
                                                    }
                                                </span>
                                            </span>
                                            :
                                            <>
                                                {(this.props.configData.kind &&
                                                    this.props.configData.conf.costDiscount[
                                                    this.props.configData.kind === 2 ? (getFieldValue("ante") !== undefined ? getFieldValue("ante") : this.props.formData.ante) : this.props.configData.kind === 6 ? (getFieldValue("multiple") !== undefined ? getFieldValue("multiple") : this.props.formData.multiple) : (getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind)
                                                    ]) === 0 ? (
                                                    <span>{this.props.language["freeLimitedTime"]}</span>
                                                ) : (
                                                    <span>
                                                        <span>
                                                            {this.props.language["everyHoursConsumeDiamond"]}：
                                                        </span>
                                                        <span
                                                            style={{
                                                                textDecoration: "line-through",
                                                                marginRight: 5,
                                                            }}
                                                        >
                                                            {this.props.language["originalPrice"]}:
                                                            {
                                                                this.props.configData.conf.cost[
                                                                this.props.configData.kind === 2 ? (getFieldValue("ante") !== undefined ? getFieldValue("ante") : this.props.formData.ante) : this.props.configData.kind === 6 ? (getFieldValue("multiple") !== undefined ? getFieldValue("multiple") : this.props.formData.multiple) : (getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind)
                                                                ]
                                                            }
                                                        </span>
                                                        ；
                                                        <span>
                                                            {this.props.language["currentPrice"]}:
                                                            {
                                                                this.props.configData.conf.costDiscount[
                                                                this.props.configData.kind === 2 ? (getFieldValue("ante") !== undefined ? getFieldValue("ante") : this.props.formData.ante) : this.props.configData.kind === 6 ? (getFieldValue("multiple") !== undefined ? getFieldValue("multiple") : this.props.formData.multiple) : (getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind)
                                                                ]
                                                            }
                                                        </span>
                                                    </span>
                                                )}
                                            </>
                                        }
                                        ）
                                    </span>
                                )}
                            </div>
                            <Button
                                style={{ marginRight: isMobileDevice() ? 0 : 30, width: isMobileDevice() ? '100%' : 'auto' }}
                                type="primary"
                                ghost
                                onClick={() => this.props.handleShow("importConfig")}
                            >
                                {this.props.importTitle}
                            </Button>
                        </Row>
                    }
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={() => this.props.onCancel("addConfig")}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                >
                    {this.props.configData.kind && (
                        <div className="container-content">
                            <Form>
                                {/* 牌局名称 */}
                                <Form.Item label={this.props.language["gambleName"]}>
                                    {getFieldDecorator("name", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["gambleNameVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.name,
                                    })(
                                        <Input
                                            maxLength={60}
                                            allowClear
                                            placeholder={this.props.language["gambleNamePlaceholder"]}
                                        />
                                    )}
                                </Form.Item>

                                {/* 手牌数量 */}
                                {(this.props.configData.kind === 4) && (
                                    <>
                                        <Form.Item
                                            label={<span>{this.props.language["handCardNumber"]}</span>}
                                        >
                                            {getFieldDecorator("game_type", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: this.props.language["handCardNumberVerify"],
                                                    },
                                                ],
                                                initialValue: this.props.formData.game_type,
                                            })(
                                                <Radio.Group>
                                                    {this.props.handCardNumberList.map((item, index) => (
                                                        <Radio value={item.value}>{item.label}</Radio>
                                                    ))}
                                                </Radio.Group>
                                            )}
                                        </Form.Item>
                                    </>
                                )}

                                {/* 即时战绩 */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 2 ||
                                    this.props.configData.kind === 4 ||
                                    this.props.configData.kind === 8) && (
                                        <>
                                            <Form.Item
                                                label={<span>{this.props.language["realTimeRecord"]}</span>}
                                            >
                                                {getFieldDecorator("show_profit_type", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: this.props.language["realTimeRecordVerify"],
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.show_profit_type,
                                                })(
                                                    <Radio.Group>
                                                        {this.props.profitTypeList.map((item, index) => (
                                                            <Radio value={item.value}>{item.label}</Radio>
                                                        ))}
                                                    </Radio.Group>
                                                )}
                                            </Form.Item>
                                        </>
                                    )}

                                {/* 游戏模式 */}
                                {this.props.configData.kind === 6 && (
                                    <Form.Item
                                        label={<span>{this.props.language["gameMode"]}</span>}
                                    >
                                        {getFieldDecorator("sub_kind", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["gameModeVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.sub_kind,
                                        })(
                                            <Radio.Group>
                                                {this.props.gameTypeList.map((item, index) => (
                                                    <Radio value={item.value}>{item.label}</Radio>
                                                ))}
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                )}

                                {/* 操作顺序 */}
                                {this.props.configData.kind === 6 && (
                                    <Form.Item
                                        label={<span>{this.props.language["operationOrder"]}</span>}
                                    >
                                        {getFieldDecorator("oper_mod", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["operationOrderVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.oper_mod,
                                        })(
                                            <Radio.Group>
                                                {this.props.operModList.map((item, index) => (
                                                    <Radio value={item.value}>{item.label}</Radio>
                                                ))}
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                )}

                                {/* 倍数 */}
                                {this.props.configData.kind === 6 && (
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["multiple"]}：
                                                {this.props.configData.conf.multiples[
                                                    getFieldValue("multiple") !== undefined ? getFieldValue("multiple") : this.props.formData.multiple
                                                ] / 100}
                                                {this.props.language["double"]}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("multiple", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["multipleVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.multiple,
                                        })(
                                            <Slider
                                                dots
                                                tipFormatter={(value) =>
                                                    String(
                                                        this.props.configData.conf.multiples[value] / 100
                                                    ) + this.props.language["double"]
                                                }
                                                min={0}
                                                max={this.props.configData.conf.multiples.length - 1}
                                            />
                                        )}
                                    </Form.Item>
                                )}

                                {/* 级别范围 */}
                                {((this.props.configData.kind === 1) ||
                                    this.props.configData.kind === 4 ||
                                    this.props.configData.kind === 8) && (
                                        <Form.Item
                                            label={
                                                <span>
                                                    {this.props.language["levelRange"]}：
                                                    {this.props.configData.conf.blinds[
                                                        getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                    ].sb / 100}
                                                    /
                                                    {this.props.configData.conf.blinds[
                                                        getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                    ].bb / 100}
                                                </span>
                                            }
                                        >
                                            {getFieldDecorator("blind", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: this.props.language["levelRangeVerify"],
                                                    },
                                                ],
                                                initialValue: this.props.formData.blind,
                                            })(
                                                <Slider
                                                    dots
                                                    tipFormatter={(value) =>
                                                        String(
                                                            this.props.configData.conf.blinds[value].sb / 100
                                                        ) +
                                                        "/" +
                                                        String(
                                                            this.props.configData.conf.blinds[value].bb / 100
                                                        )
                                                    }
                                                    min={0}
                                                    max={this.props.configData.conf.blinds.length - 1}
                                                    onChange={(value) => this.props.handleChangeHang('blind', value)}
                                                />
                                            )}
                                        </Form.Item>
                                    )}

                                {/* 夯场模式（开关） */}
                                {(this.props.configData.kind === 1) && (
                                    <Alert className='mb20' message={
                                        <Form.Item className='m0' label={
                                            <span>
                                                <span>{this.props.language["hangMode"]}：</span>
                                                {getFieldValue("is_hang") && <span style={{ color: '#FF4D4F' }}>{this.props.language["hangModeTips"]}</span>}
                                            </span>
                                        } labelCol={{ span: 22 }} wrapperCol={{ span: 1 }} labelAlign="left" colon={false}>
                                            {getFieldDecorator("is_hang", {
                                                initialValue: this.props.formData.is_hang,
                                                valuePropName: "checked",
                                            })(
                                                <Switch disabled={getFieldValue("is_hang")} onChange={(value) => this.props.handleChangeHang('is_hang', value)} />
                                            )}
                                        </Form.Item>
                                    } type="info">
                                    </Alert>
                                )}

                                {/* 夯场模式（前注） */}
                                {((this.props.configData.kind === 1 && getFieldValue("is_hang"))) && (
                                    <Form.Item
                                        label={<span>{this.props.language["foreword"]}</span>}
                                    >
                                        {getFieldDecorator("ante_hang_value", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["forewordVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.ante_hang_value,
                                        })(
                                            <Radio.Group onChange={(e) => this.props.handleChangeHang('ante_hange_value', e.target.value)}>
                                                {this.props.configData.conf.hangAntes.map((item, index) => (
                                                    <Radio value={item}>{item}BB</Radio>
                                                ))}
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                )}

                                {/* 前注 */}
                                {((this.props.configData.kind === 1 && !getFieldValue("is_hang")) ||
                                    this.props.configData.kind === 4 ||
                                    this.props.configData.kind === 8) && (
                                        <Form.Item
                                            label={
                                                <span>
                                                    {this.props.language["foreword"]}：
                                                    {this.props.configData.conf.blinds[
                                                        getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                    ].antes[
                                                        getFieldValue("ante") !== undefined ? getFieldValue("ante") : this.props.formData.ante
                                                    ] / 100}
                                                </span>
                                            }
                                        >
                                            {getFieldDecorator("ante", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: this.props.language["forewordVerify"],
                                                    },
                                                ],
                                                initialValue: this.props.formData.ante,
                                            })(
                                                <Slider
                                                    dots
                                                    tipFormatter={(value) =>
                                                        String(
                                                            this.props.configData.conf.blinds[
                                                                getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                            ].antes[value] / 100
                                                        )
                                                    }
                                                    min={0}
                                                    max={
                                                        this.props.configData.conf.blinds[
                                                            getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                        ].antes.length - 1
                                                    }
                                                    onChange={(value) => this.props.handleChangeHang('ante', value)}
                                                />
                                            )}
                                        </Form.Item>
                                    )}

                                {/* 前注 */}
                                {this.props.configData.kind === 2 && (
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["foreword"]}：
                                                {this.props.configData.conf.shortAntes[
                                                    getFieldValue("ante") !== undefined ? getFieldValue("ante") : this.props.formData.ante
                                                ] / 100}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("ante", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["forewordVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.ante,
                                        })(
                                            <Slider
                                                dots
                                                tipFormatter={(value) =>
                                                    String(
                                                        this.props.configData.conf.shortAntes[value] / 100
                                                    )
                                                }
                                                min={0}
                                                max={this.props.configData.conf.shortAntes.length - 1}
                                            />
                                        )}
                                    </Form.Item>
                                )}

                                {/* 带入范围 */}
                                {(this.props.configData.kind === 1 || this.props.configData.kind === 4) && (
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["bringRange"]}：
                                                {this.props.configData.conf.buyins[
                                                    getFieldValue("carry_range")
                                                        ? getFieldValue("carry_range")[0]
                                                        : this.props.formData.carry_range[0]
                                                ] *
                                                    (this.props.configData.conf.blinds[
                                                        getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                    ].bb /
                                                        100)}
                                                -
                                                {this.props.configData.conf.buyins[
                                                    getFieldValue("carry_range")
                                                        ? getFieldValue("carry_range")[1]
                                                        : this.props.formData.carry_range[1]
                                                ] *
                                                    (this.props.configData.conf.blinds[
                                                        getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                    ].bb /
                                                        100)}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("carry_range", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["bringRangeVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.carry_range,
                                        })(
                                            <Slider
                                                range
                                                dots
                                                tipFormatter={(value) =>
                                                    String(
                                                        this.props.configData.conf.buyins[value] *
                                                        (this.props.configData.conf.blinds[
                                                            getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                        ].bb /
                                                            100)
                                                    )
                                                }
                                                min={0}
                                                max={this.props.configData.conf.buyins.length - 1}
                                                onChange={(value) => this.props.handleChangeHang('carry_range', value)}
                                            />
                                        )}
                                    </Form.Item>
                                )}

                                {/* 带入范围 */}
                                {this.props.configData.kind === 2 && (
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["bringRange"]}：
                                                {this.props.configData.conf.buyins[
                                                    getFieldValue("carry_range")
                                                        ? getFieldValue("carry_range")[0]
                                                        : this.props.formData.carry_range[0]
                                                ] *
                                                    (this.props.configData.conf.shortAntes[
                                                        getFieldValue("ante") !== undefined ? getFieldValue("ante") : this.props.formData.ante
                                                    ] /
                                                        100)}
                                                -
                                                {this.props.configData.conf.buyins[
                                                    getFieldValue("carry_range")
                                                        ? getFieldValue("carry_range")[1]
                                                        : this.props.formData.carry_range[1]
                                                ] *
                                                    (this.props.configData.conf.shortAntes[
                                                        getFieldValue("ante") !== undefined ? getFieldValue("ante") : this.props.formData.ante
                                                    ] /
                                                        100)}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("carry_range", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["bringRangeVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.carry_range,
                                        })(
                                            <Slider
                                                range
                                                dots
                                                tipFormatter={(value) =>
                                                    String(
                                                        this.props.configData.conf.buyins[value] *
                                                        (this.props.configData.conf.shortAntes[
                                                            getFieldValue("ante") !== undefined ? getFieldValue("ante") : this.props.formData.ante
                                                        ] /
                                                            100)
                                                    )
                                                }
                                                min={0}
                                                max={this.props.configData.conf.buyins.length - 1}
                                            />
                                        )}
                                    </Form.Item>
                                )}

                                {/* 带入范围 */}
                                {this.props.configData.kind === 6 && (
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["bringRange"]}：
                                                {this.props.configData.conf.buyins[
                                                    getFieldValue("carry_range")
                                                        ? getFieldValue("carry_range")[0]
                                                        : this.props.formData.carry_range[0]
                                                ] *
                                                    (this.props.configData.conf.multiples[
                                                        getFieldValue("multiple") !== undefined ? getFieldValue("multiple") : this.props.formData.multiple
                                                    ] /
                                                        100)}
                                                -
                                                {this.props.configData.conf.buyins[
                                                    getFieldValue("carry_range")
                                                        ? getFieldValue("carry_range")[1]
                                                        : this.props.formData.carry_range[1]
                                                ] *
                                                    (this.props.configData.conf.multiples[
                                                        getFieldValue("multiple") !== undefined ? getFieldValue("multiple") : this.props.formData.multiple
                                                    ] /
                                                        100)}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("carry_range", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["bringRangeVerify"],
                                                },
                                            ],
                                            initialValue: [this.props.formData.carry_range[0], this.props.formData.carry_range[1]],
                                        })(
                                            <Slider
                                                range
                                                dots
                                                tipFormatter={(value) =>
                                                    String(
                                                        this.props.configData.conf.buyins[value] *
                                                        (this.props.configData.conf.multiples[
                                                            getFieldValue("multiple") !== undefined ? getFieldValue("multiple") : this.props.formData.multiple
                                                        ] /
                                                            100)
                                                    )
                                                }
                                                min={0}
                                                max={this.props.configData.conf.buyins.length - 1}
                                            />
                                        )}
                                    </Form.Item>
                                )}

                                {/* 最小带入 */}
                                {this.props.configData.kind === 8 && (
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["minSubstitution"]}：
                                                {this.props.configData.conf.buyins[
                                                    getFieldValue("min_carry") !== undefined ? getFieldValue("min_carry") : this.props.formData.min_carry
                                                ] *
                                                    (this.props.configData.conf.blinds[
                                                        getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                    ].bb /
                                                        100)}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("min_carry", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["minSubstitutionVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.min_carry,
                                        })(
                                            <Slider
                                                dots
                                                tipFormatter={(value) =>
                                                    String(
                                                        this.props.configData.conf.buyins[value] *
                                                        (this.props.configData.conf.blinds[
                                                            getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                        ].bb /
                                                            100)
                                                    )
                                                }
                                                min={0}
                                                max={this.props.configData.conf.buyins.length - 1}
                                            />
                                        )}
                                    </Form.Item>
                                )}
                                {/* 最低入局 */}
                                {this.props.configData.kind === 6 && (
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["minEntryPoint"]}：
                                                {this.props.configData.conf.buyins[getFieldValue("carry_range") ? getFieldValue("carry_range")[0] : this.props.formData.carry_range[0]]
                                                    * (this.props.configData.conf.multiples[getFieldValue("multiple") !== undefined ? getFieldValue("multiple") : this.props.formData.multiple] / 100)
                                                    * ((getFieldValue("min_play") !== undefined ? getFieldValue("min_play") : this.props.formData.min_play) + 1) / 10}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("min_play", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["minEntryPointVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.min_play,
                                        })(
                                            <Slider
                                                dots
                                                tipFormatter={(value) =>
                                                    String(
                                                        this.props.configData.conf.buyins[getFieldValue("carry_range") ? getFieldValue("carry_range")[0] : this.props.formData.carry_range[0]]
                                                        * (this.props.configData.conf.multiples[getFieldValue("multiple") !== undefined ? getFieldValue("multiple") : this.props.formData.multiple] / 100)
                                                        * this.props.configData.conf.minPlays[value]
                                                        / this.props.configData.conf.minPlays.length
                                                    )
                                                }
                                                min={0}
                                                max={this.props.configData.conf.minPlays.length - 1}
                                            />
                                        )}
                                    </Form.Item>
                                )}

                                {/* 服务费 */}
                                <Form.Item
                                    label={
                                        <span>
                                            {this.props.language["serviceFee"]}：
                                            {this.props.configData.conf.potFeeRates[
                                                getFieldValue("pot_fee_rate") !== undefined ? getFieldValue("pot_fee_rate") : this.props.formData.pot_fee_rate
                                            ] / 100}
                                            %
                                        </span>
                                    }
                                >
                                    {getFieldDecorator("pot_fee_rate", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["serviceFeeVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.pot_fee_rate,
                                    })(
                                        <Slider
                                            dots
                                            tipFormatter={(value) =>
                                                String(
                                                    this.props.configData.conf.potFeeRates[value] / 100
                                                ) + "%"
                                            }
                                            min={0}
                                            max={this.props.configData.conf.potFeeRates.length - 1}
                                        />
                                    )}
                                </Form.Item>

                                {/* 服务费封顶 */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 4 ||
                                    this.props.configData.kind === 8) && (
                                        <Form.Item
                                            label={
                                                <span>
                                                    {this.props.language["serviceFeeCap"]}：
                                                    {(getFieldValue("pot_fee_hand_limit") !== undefined ? getFieldValue("pot_fee_hand_limit") : this.props.formData.pot_fee_hand_limit) ===
                                                        this.props.configData.conf.potFeeHandLimitSbs.length - 1
                                                        ? this.props.language["unlimited"]
                                                        : this.props.configData.conf.potFeeHandLimitSbs[
                                                        getFieldValue("pot_fee_hand_limit") !== undefined ? getFieldValue("pot_fee_hand_limit") : this.props.formData.pot_fee_hand_limit
                                                        ] /
                                                        2 +
                                                        "BB"}
                                                </span>
                                            }
                                        >
                                            {getFieldDecorator("pot_fee_hand_limit", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: this.props.language["serviceFeeCapVerify"],
                                                    },
                                                ],
                                                initialValue: this.props.formData.pot_fee_hand_limit,
                                            })(
                                                <Slider
                                                    dots
                                                    tipFormatter={(value) =>
                                                        value ===
                                                            this.props.configData.conf.potFeeHandLimitSbs.length -
                                                            1
                                                            ? this.props.language["unlimited"]
                                                            : String(
                                                                this.props.configData.conf.potFeeHandLimitSbs[
                                                                value
                                                                ] / 2
                                                            ) + "BB"
                                                    }
                                                    min={0}
                                                    max={
                                                        this.props.configData.conf.potFeeHandLimitSbs.length -
                                                        1
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    )}

                                {/* 服务费封顶 */}
                                {this.props.configData.kind === 2 && (
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["serviceFeeCap"]}：
                                                {(getFieldValue("pot_fee_hand_limit") !== undefined ? getFieldValue("pot_fee_hand_limit") : this.props.formData.pot_fee_hand_limit) ===
                                                    this.props.configData.conf.potFeeHandLimitAntes.length -
                                                    1
                                                    ? this.props.language["unlimited"]
                                                    : this.props.configData.conf.potFeeHandLimitAntes[
                                                    getFieldValue("pot_fee_hand_limit") !== undefined ? getFieldValue("pot_fee_hand_limit") : this.props.formData.pot_fee_hand_limit
                                                    ] /
                                                    2 +
                                                    "BB"}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("pot_fee_hand_limit", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["serviceFeeCapVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.pot_fee_hand_limit,
                                        })(
                                            <Slider
                                                dots
                                                tipFormatter={(value) =>
                                                    value ===
                                                        this.props.configData.conf.potFeeHandLimitAntes
                                                            .length -
                                                        1
                                                        ? this.props.language["unlimited"]
                                                        : String(
                                                            this.props.configData.conf.potFeeHandLimitAntes[
                                                            value
                                                            ] / 2
                                                        ) + "BB"
                                                }
                                                min={0}
                                                max={
                                                    this.props.configData.conf.potFeeHandLimitAntes
                                                        .length - 1
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                )}

                                {/* 服务费封顶 */}
                                {this.props.configData.kind === 6 && (
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["serviceFeeCap"]}：
                                                {(getFieldValue("pot_fee_hand_limit") !== undefined ? getFieldValue("pot_fee_hand_limit") : this.props.formData.pot_fee_hand_limit) ===
                                                    this.props.configData.conf.potFeeHandLimitMulti.length -
                                                    1
                                                    ? this.props.language["unlimited"]
                                                    : this.props.configData.conf.potFeeHandLimitMulti[
                                                    getFieldValue("pot_fee_hand_limit") !== undefined ? getFieldValue("pot_fee_hand_limit") : this.props.formData.pot_fee_hand_limit
                                                    ] /
                                                    2 +
                                                    "BB"}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("pot_fee_hand_limit", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["serviceFeeCapVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.pot_fee_hand_limit,
                                        })(
                                            <Slider
                                                dots
                                                tipFormatter={(value) =>
                                                    value ===
                                                        this.props.configData.conf.potFeeHandLimitMulti
                                                            .length -
                                                        1
                                                        ? this.props.language["unlimited"]
                                                        : String(
                                                            this.props.configData.conf.potFeeHandLimitMulti[
                                                            value
                                                            ] / 2
                                                        ) + "BB"
                                                }
                                                min={0}
                                                max={
                                                    this.props.configData.conf.potFeeHandLimitMulti
                                                        .length - 1
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                )}

                                {/* 思考时间 */}
                                <Form.Item
                                    label={
                                        <span>
                                            {this.props.language["thinkTime"]}：
                                            {
                                                this.props.configData.conf.actionTimes[
                                                getFieldValue("action_time") !== undefined ? getFieldValue("action_time") : this.props.formData.action_time
                                                ]
                                            }
                                            {this.props.language["second"]}
                                        </span>
                                    }
                                >
                                    {getFieldDecorator("action_time", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["thinkTimeVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.action_time,
                                    })(
                                        <Slider
                                            dots
                                            tipFormatter={(value) =>
                                                String(this.props.configData.conf.actionTimes[value]) +
                                                this.props.language["second"]
                                            }
                                            min={0}
                                            max={this.props.configData.conf.actionTimes.length - 1}
                                        />
                                    )}
                                </Form.Item>

                                {/* 时间 */}
                                <Form.Item
                                    label={
                                        <span>
                                            {this.props.language["time"]}：：
                                            {this.props.configData.conf.matchTimes[
                                                getFieldValue("match_time") !== undefined ? getFieldValue("match_time") : this.props.formData.match_time
                                            ] / 3600}
                                            {this.props.language["hour"]}
                                        </span>
                                    }
                                >
                                    {getFieldDecorator("match_time", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["timeVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.match_time,
                                    })(
                                        <Slider
                                            dots
                                            tipFormatter={(value) =>
                                                String(
                                                    this.props.configData.conf.matchTimes[value] / 3600
                                                ) + this.props.language["hour"]
                                            }
                                            min={0}
                                            max={this.props.configData.conf.matchTimes.length - 1}
                                        />
                                    )}
                                </Form.Item>

                                {/* 自动延时次数 */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 2 ||
                                    this.props.configData.kind === 4 ||
                                    this.props.configData.kind === 8) && (
                                        <Form.Item
                                            label={
                                                <span>
                                                    {this.props.language["delayTime"]}：
                                                    {
                                                        this.props.configData.conf.autoDelayTimes[
                                                        getFieldValue("auto_delay_times") !== undefined ? getFieldValue("auto_delay_times") : this.props.formData.auto_delay_times
                                                        ]
                                                    }
                                                    {this.props.language["count"]}
                                                </span>
                                            }
                                        >
                                            {getFieldDecorator("auto_delay_times", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: this.props.language["delayTimeVerify"],
                                                    },
                                                ],
                                                initialValue: this.props.formData.auto_delay_times,
                                            })(
                                                <Slider
                                                    dots
                                                    tipFormatter={(value) =>
                                                        String(
                                                            this.props.configData.conf.autoDelayTimes[value]
                                                        ) + this.props.language["count"]
                                                    }
                                                    min={0}
                                                    max={
                                                        this.props.configData.conf.autoDelayTimes.length - 1
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    )}

                                {/* 人数 */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 4 ||
                                    this.props.configData.kind === 8) && (
                                        <Form.Item
                                            label={
                                                <span>
                                                    {this.props.language["peopleNumber"]}：
                                                    {
                                                        this.props.configData.conf.texasUserNums[
                                                        getFieldValue("seat_num") !== undefined ? getFieldValue("seat_num") : this.props.formData.seat_num
                                                        ]
                                                    }
                                                    {this.props.language["person"]}
                                                </span>
                                            }
                                        >
                                            {getFieldDecorator("seat_num", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: this.props.language["peopleNumberVerify"],
                                                    },
                                                ],
                                                initialValue: this.props.formData.seat_num,
                                            })(
                                                <Slider
                                                    dots
                                                    tipFormatter={(value) =>
                                                        String(
                                                            this.props.configData.conf.texasUserNums[value]
                                                        ) + this.props.language["person"]
                                                    }
                                                    min={0}
                                                    max={
                                                        this.props.configData.conf.texasUserNums.length - 1
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    )}

                                {/* 人数 */}
                                {this.props.configData.kind === 2 && (
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["peopleNumber"]}：
                                                {
                                                    this.props.configData.conf.shortUserNums[
                                                    getFieldValue("seat_num") !== undefined ? getFieldValue("seat_num") : this.props.formData.seat_num
                                                    ]
                                                }
                                                {this.props.language["person"]}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("seat_num", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["peopleNumberVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.seat_num,
                                        })(
                                            <Slider
                                                dots
                                                tipFormatter={(value) =>
                                                    String(
                                                        this.props.configData.conf.shortUserNums[value]
                                                    ) + this.props.language["person"]
                                                }
                                                min={0}
                                                max={
                                                    this.props.configData.conf.shortUserNums.length - 1
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                )}

                                {/* 人数 */}
                                {this.props.configData.kind === 6 && (
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["peopleNumber"]}：
                                                {
                                                    this.props.configData.conf.ofcUserNums[
                                                    getFieldValue("seat_num") !== undefined ? getFieldValue("seat_num") : this.props.formData.seat_num
                                                    ]
                                                }
                                                {this.props.language["person"]}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("seat_num", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["peopleNumberVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.seat_num,
                                        })(
                                            <Slider
                                                dots
                                                tipFormatter={(value) =>
                                                    String(
                                                        this.props.configData.conf.ofcUserNums[value]
                                                    ) + this.props.language["person"]
                                                }
                                                min={0}
                                                max={this.props.configData.conf.ofcUserNums.length - 1}
                                            />
                                        )}
                                    </Form.Item>
                                )}

                                {/* 自动开始人数 */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 4 ||
                                    this.props.configData.kind === 8) && (
                                        <>
                                            <Form.Item label={this.props.language["autoStartPeople"]}>
                                                {getFieldDecorator("is_auto_start_user_num", {
                                                    initialValue: this.props.formData.is_auto_start_user_num,
                                                    valuePropName: "checked",
                                                })(<Switch />)}
                                            </Form.Item>
                                            {(getFieldValue("is_auto_start_user_num") !== undefined ? getFieldValue("is_auto_start_user_num") : this.props.formData.is_auto_start_user_num) && (
                                                <Form.Item
                                                    label={
                                                        <span>
                                                            {this.props.language["autoStartPeople"]}：
                                                            {
                                                                this.props.configData.conf.texasUserNums[
                                                                getFieldValue("auto_start_user_num") !== undefined ? getFieldValue("auto_start_user_num") : this.props.formData.auto_start_user_num
                                                                ]
                                                            }
                                                            {this.props.language["person"]}
                                                        </span>
                                                    }
                                                >
                                                    {getFieldDecorator("auto_start_user_num", {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message:
                                                                    this.props.language["autoStartPeopleVerify"],
                                                            },
                                                        ],
                                                        initialValue: this.props.formData.auto_start_user_num,
                                                    })(
                                                        <Slider
                                                            dots
                                                            tipFormatter={(value) =>
                                                                String(
                                                                    this.props.configData.conf.texasUserNums[value]
                                                                ) + this.props.language["person"]
                                                            }
                                                            min={0}
                                                            max={
                                                                this.props.configData.conf.texasUserNums.length -
                                                                1
                                                            }
                                                        />
                                                    )}
                                                </Form.Item>
                                            )}
                                        </>
                                    )}

                                {/* 自动开始人数 */}
                                {this.props.configData.kind === 2 && (
                                    <>
                                        <Form.Item label={this.props.language["autoStartPeople"]}>
                                            {getFieldDecorator("is_auto_start_user_num", {
                                                initialValue: this.props.formData.is_auto_start_user_num,
                                                valuePropName: "checked",
                                            })(<Switch />)}
                                        </Form.Item>
                                        {(getFieldValue("is_auto_start_user_num") !== undefined ? getFieldValue("is_auto_start_user_num") : this.props.formData.is_auto_start_user_num) && (
                                            <Form.Item
                                                label={
                                                    <span>
                                                        {this.props.language["autoStartPeople"]}：
                                                        {
                                                            this.props.configData.conf.shortUserNums[
                                                            getFieldValue("auto_start_user_num") !== undefined ? getFieldValue("auto_start_user_num") : this.props.formData.auto_start_user_num
                                                            ]
                                                        }
                                                        {this.props.language["person"]}
                                                    </span>
                                                }
                                            >
                                                {getFieldDecorator("auto_start_user_num", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message:
                                                                this.props.language["autoStartPeopleVerify"],
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.auto_start_user_num,
                                                })(
                                                    <Slider
                                                        dots
                                                        tipFormatter={(value) =>
                                                            String(
                                                                this.props.configData.conf.shortUserNums[value]
                                                            ) + this.props.language["person"]
                                                        }
                                                        min={0}
                                                        max={
                                                            this.props.configData.conf.shortUserNums.length -
                                                            1
                                                        }
                                                    />
                                                )}
                                            </Form.Item>
                                        )}
                                    </>
                                )}

                                {/* 自动开始人数 */}
                                {this.props.configData.kind === 6 && (
                                    <>
                                        <Form.Item label={this.props.language["autoStartPeople"]}>
                                            {getFieldDecorator("is_auto_start_user_num", {
                                                initialValue: this.props.formData.is_auto_start_user_num,
                                                valuePropName: "checked",
                                            })(<Switch />)}
                                        </Form.Item>
                                        {(getFieldValue("is_auto_start_user_num") !== undefined ? getFieldValue("is_auto_start_user_num") : this.props.formData.is_auto_start_user_num) && (
                                            <Form.Item
                                                label={
                                                    <span>
                                                        {this.props.language["autoStartPeople"]}：
                                                        {
                                                            this.props.configData.conf.ofcUserNums[
                                                            getFieldValue("auto_start_user_num") !== undefined ? getFieldValue("auto_start_user_num") : this.props.formData.auto_start_user_num
                                                            ]
                                                        }
                                                        {this.props.language["person"]}
                                                    </span>
                                                }
                                            >
                                                {getFieldDecorator("auto_start_user_num", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message:
                                                                this.props.language["autoStartPeopleVerify"],
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.auto_start_user_num,
                                                })(
                                                    <Slider
                                                        dots
                                                        tipFormatter={(value) =>
                                                            String(
                                                                this.props.configData.conf.ofcUserNums[value]
                                                            ) + this.props.language["person"]
                                                        }
                                                        min={0}
                                                        max={
                                                            this.props.configData.conf.ofcUserNums.length - 1
                                                        }
                                                    />
                                                )}
                                            </Form.Item>
                                        )}
                                    </>
                                )}

                                {/* 自动卸码 */}
                                {this.props.configData.kind === 2 && (
                                    <>
                                        <Form.Item label={this.props.language["autoUnloadCode"]}>
                                            {getFieldDecorator("is_unload_times", {
                                                initialValue: this.props.formData.is_unload_times,
                                                valuePropName: "checked",
                                            })(<Switch />)}
                                        </Form.Item>
                                        {(getFieldValue("is_unload_times") !== undefined ? getFieldValue("is_unload_times") : this.props.formData.is_unload_times) && (
                                            <Form.Item
                                                label={
                                                    <span>
                                                        {this.props.language["autoUnloadNumber"]}：
                                                        {this.props.configData.conf.unloadTimes[
                                                            getFieldValue("unload_times") !== undefined ? getFieldValue("unload_times") : this.props.formData.unload_times
                                                        ] / 100}
                                                    </span>
                                                }
                                            >
                                                {getFieldDecorator("unload_times", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message:
                                                                this.props.language["autoUnloadNumberVerify"],
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.unload_times,
                                                })(
                                                    <Slider
                                                        dots
                                                        tipFormatter={(value) =>
                                                            String(
                                                                this.props.configData.conf.unloadTimes[value] /
                                                                100
                                                            )
                                                        }
                                                        min={0}
                                                        max={
                                                            this.props.configData.conf.unloadTimes.length - 1
                                                        }
                                                    />
                                                )}
                                            </Form.Item>
                                        )}
                                    </>
                                )}

                                {/* 27彩池 */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 4) && (
                                        <>
                                            <Form.Item label={this.props.language["colorPool"]}>
                                                {getFieldDecorator("is_two_seven_bonus", {
                                                    initialValue: this.props.formData.is_two_seven_bonus,
                                                    valuePropName: "checked",
                                                })(<Switch />)}
                                            </Form.Item>
                                            {(getFieldValue("is_two_seven_bonus") !== undefined ? getFieldValue("is_two_seven_bonus") : this.props.formData.is_two_seven_bonus) && (
                                                <Form.Item
                                                    label={
                                                        <span>
                                                            {this.props.language["lotteryPoolPrize"]}：
                                                            {
                                                                this.props.configData.conf.twoSevenBonuses[
                                                                getFieldValue("two_seven_bonus") !== undefined ? getFieldValue("two_seven_bonus") : this.props.formData.two_seven_bonus
                                                                ]
                                                            }
                                                            BB
                                                        </span>
                                                    }
                                                >
                                                    {getFieldDecorator("two_seven_bonus", {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message:
                                                                    this.props.language["lotteryPoolPrizeVerify"],
                                                            },
                                                        ],
                                                        initialValue: this.props.formData.two_seven_bonus,
                                                    })(
                                                        <Slider
                                                            dots
                                                            tipFormatter={(value) =>
                                                                String(
                                                                    this.props.configData.conf.twoSevenBonuses[
                                                                    value
                                                                    ]
                                                                ) + "BB"
                                                            }
                                                            min={0}
                                                            max={
                                                                this.props.configData.conf.twoSevenBonuses
                                                                    .length - 1
                                                            }
                                                        />
                                                    )}
                                                </Form.Item>
                                            )}
                                        </>
                                    )}

                                {/* Rathole */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 2 ||
                                    this.props.configData.kind === 4) && (
                                        <>
                                            <Form.Item label="Rathole">
                                                {getFieldDecorator("is_rathole", {
                                                    initialValue: this.props.formData.is_rathole,
                                                    valuePropName: "checked",
                                                })(
                                                    (getFieldValue("is_squid") !== undefined ? getFieldValue("is_squid") : this.props.formData.is_squid) ? (
                                                        <Tooltip
                                                            placement="right"
                                                            title={this.props.language["ratholeDisabledTips"]}
                                                        >
                                                            <Switch disabled={getFieldValue("is_squid") !== undefined ? getFieldValue("is_squid") : this.props.formData.is_squid} />
                                                        </Tooltip>
                                                    ) : (
                                                        <Switch />
                                                    )
                                                )}
                                            </Form.Item>
                                            {(getFieldValue("is_rathole") !== undefined ? getFieldValue("is_rathole") : this.props.formData.is_rathole) && (
                                                <Form.Item
                                                    label={
                                                        <span>
                                                            {this.props.language["time"]}：
                                                            {
                                                                this.props.configData.conf.ratholeMinutes[
                                                                getFieldValue("rathole_minute") !== undefined ? getFieldValue("rathole_minute") : this.props.formData.rathole_minute
                                                                ]
                                                            }
                                                            {this.props.language["minute"]}
                                                        </span>
                                                    }
                                                >
                                                    {getFieldDecorator("rathole_minute", {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: this.props.language["timeVerify"],
                                                            },
                                                        ],
                                                        initialValue: this.props.formData.rathole_minute,
                                                    })(
                                                        <Slider
                                                            dots
                                                            tipFormatter={(value) =>
                                                                String(
                                                                    this.props.configData.conf.ratholeMinutes[
                                                                    value
                                                                    ]
                                                                ) + this.props.language["minute"]
                                                            }
                                                            min={0}
                                                            max={
                                                                this.props.configData.conf.ratholeMinutes
                                                                    .length - 1
                                                            }
                                                        />
                                                    )}
                                                </Form.Item>
                                            )}
                                        </>
                                    )}

                                {/* CallTime */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 2 ||
                                    this.props.configData.kind === 4) && (
                                        <>
                                            <Form.Item label="CallTime">
                                                {getFieldDecorator("is_call_time", {
                                                    initialValue: this.props.formData.is_call_time,
                                                    valuePropName: "checked",
                                                })(
                                                    (getFieldValue("is_squid") !== undefined ? getFieldValue("is_squid") : this.props.formData.is_squid) ? (
                                                        <Tooltip
                                                            placement="right"
                                                            title={this.props.language["callTimeDisabledTips"]}
                                                        >
                                                            <Switch disabled={getFieldValue("is_squid") !== undefined ? getFieldValue("is_squid") : this.props.formData.is_squid} />
                                                        </Tooltip>
                                                    ) : (
                                                        <Switch />
                                                    )
                                                )}
                                            </Form.Item>
                                            {(getFieldValue("is_call_time") !== undefined ? getFieldValue("is_call_time") : this.props.formData.is_call_time) && (
                                                <>
                                                    <Form.Item
                                                        label={
                                                            <span>
                                                                {this.props.language["profitTrigger"]}：
                                                                {
                                                                    this.props.configData.conf.callTimeProfits[
                                                                    getFieldValue("call_time_profit") !== undefined ? getFieldValue("call_time_profit") : this.props.formData.call_time_profit
                                                                    ]
                                                                }
                                                                BB
                                                            </span>
                                                        }
                                                    >
                                                        {getFieldDecorator("call_time_profit", {
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message:
                                                                        this.props.language["profitTriggerVerify"],
                                                                },
                                                            ],
                                                            initialValue: this.props.formData.call_time_profit,
                                                        })(
                                                            <Slider
                                                                dots
                                                                tipFormatter={(value) =>
                                                                    String(
                                                                        this.props.configData.conf.callTimeProfits[
                                                                        value
                                                                        ]
                                                                    ) + "BB"
                                                                }
                                                                min={0}
                                                                max={
                                                                    this.props.configData.conf.callTimeProfits
                                                                        .length - 1
                                                                }
                                                            />
                                                        )}
                                                    </Form.Item>
                                                    <Form.Item
                                                        label={
                                                            <span>{this.props.language["triggerType"]}</span>
                                                        }
                                                    >
                                                        {getFieldDecorator("call_time_lift_type", {
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message:
                                                                        this.props.language["triggerTypeVerify"],
                                                                },
                                                            ],
                                                            initialValue:
                                                                this.props.formData.call_time_lift_type,
                                                        })(
                                                            <Radio.Group>
                                                                {this.props.typeList.map((item, index) => (
                                                                    <Radio value={item.value}>{item.label}</Radio>
                                                                ))}
                                                            </Radio.Group>
                                                        )}
                                                    </Form.Item>
                                                    {(getFieldValue("call_time_lift_type") !== undefined ? getFieldValue("call_time_lift_type") : this.props.formData.call_time_lift_type) === 1 && (
                                                        <Form.Item
                                                            label={
                                                                <span>
                                                                    {this.props.language["leaveCondition"]}：
                                                                    {
                                                                        this.props.configData.conf.callTimeLiftHands[
                                                                        getFieldValue("call_time_lift_hand") !== undefined ? getFieldValue("call_time_lift_hand") : this.props.formData.call_time_lift_hand
                                                                        ]
                                                                    }
                                                                    {this.props.language["hand"]}
                                                                </span>
                                                            }
                                                        >
                                                            {getFieldDecorator("call_time_lift_hand", {
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            this.props.language["leaveConditionVerify"],
                                                                    },
                                                                ],
                                                                initialValue:
                                                                    this.props.formData.call_time_lift_hand,
                                                            })(
                                                                <Slider
                                                                    dots
                                                                    tipFormatter={(value) =>
                                                                        String(
                                                                            this.props.configData.conf
                                                                                .callTimeLiftHands[value]
                                                                        ) + this.props.language["hand"]
                                                                    }
                                                                    min={0}
                                                                    max={
                                                                        this.props.configData.conf.callTimeLiftHands
                                                                            .length - 1
                                                                    }
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    )}
                                                    {(getFieldValue("call_time_lift_type") !== undefined ? getFieldValue("call_time_lift_type") : this.props.formData.call_time_lift_type) === 2 && (
                                                        <Form.Item
                                                            label={
                                                                <span>
                                                                    {this.props.language["leaveCondition"]}：
                                                                    {
                                                                        this.props.configData.conf
                                                                            .callTimeLiftMinutes[
                                                                        getFieldValue("call_time_lift_minute") !== undefined ? getFieldValue("call_time_lift_minute") : this.props.formData.call_time_lift_minute
                                                                        ]
                                                                    }
                                                                    {this.props.language["minute"]}
                                                                </span>
                                                            }
                                                        >
                                                            {getFieldDecorator("call_time_lift_minute", {
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            this.props.language["leaveConditionVerify"],
                                                                    },
                                                                ],
                                                                initialValue:
                                                                    this.props.formData.call_time_lift_minute,
                                                            })(
                                                                <Slider
                                                                    dots
                                                                    tipFormatter={(value) =>
                                                                        String(
                                                                            this.props.configData.conf
                                                                                .callTimeLiftMinutes[value]
                                                                        ) + this.props.language["minute"]
                                                                    }
                                                                    min={0}
                                                                    max={
                                                                        this.props.configData.conf.callTimeLiftMinutes
                                                                            .length - 1
                                                                    }
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}

                                {/* Bomb模式 */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 2 ||
                                    this.props.configData.kind === 4) && (
                                        <>
                                            <Form.Item label={this.props.language["bombMode"]}>
                                                {getFieldDecorator("is_boom", {
                                                    initialValue: this.props.formData.is_boom,
                                                    valuePropName: "checked",
                                                })(
                                                    (getFieldValue("is_sushi") !== undefined ? getFieldValue("is_sushi") : this.props.formData.is_sushi) ? (
                                                        <Tooltip
                                                            placement="right"
                                                            title={this.props.language["bombDisabledTips"]}
                                                        >
                                                            <Switch disabled={getFieldValue("is_sushi") !== undefined ? getFieldValue("is_sushi") : this.props.formData.is_sushi} />
                                                        </Tooltip>
                                                    ) : (
                                                        <Switch />
                                                    )
                                                )}
                                            </Form.Item>
                                            {(getFieldValue("is_boom") !== undefined ? getFieldValue("is_boom") : this.props.formData.is_boom) && (
                                                <>
                                                    <Form.Item
                                                        label={
                                                            <span>
                                                                {this.props.language["boomRandomPoolBetRange"]}：
                                                                {
                                                                    this.props.configData.conf.boomRandBets[
                                                                    getFieldValue("boom_range")
                                                                        ? getFieldValue("boom_range")[0]
                                                                        : this.props.formData.boom_range[0]
                                                                    ]
                                                                }
                                                                BB -
                                                                {
                                                                    this.props.configData.conf.boomRandBets[
                                                                    getFieldValue("boom_range")
                                                                        ? getFieldValue("boom_range")[1]
                                                                        : this.props.formData.boom_range[1]
                                                                    ]
                                                                }
                                                                BB
                                                            </span>
                                                        }
                                                    >
                                                        {getFieldDecorator("boom_range", {
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message:
                                                                        this.props.language[
                                                                        "boomRandomPoolBetRangeVerify"
                                                                        ],
                                                                },
                                                            ],
                                                            initialValue: this.props.formData.boom_range,
                                                        })(
                                                            <Slider
                                                                range
                                                                dots
                                                                tipFormatter={(value) =>
                                                                    String(
                                                                        this.props.configData.conf.boomRandBets[value]
                                                                    ) + "BB"
                                                                }
                                                                min={0}
                                                                max={
                                                                    this.props.configData.conf.boomRandBets.length - 1
                                                                }
                                                            />
                                                        )}
                                                    </Form.Item>
                                                    <Form.Item
                                                        label={<span>{this.props.language["boomType"]}：</span>}
                                                    >
                                                        {getFieldDecorator("boom_type", {
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: this.props.language["boomTypeVerify"],
                                                                },
                                                            ],
                                                            initialValue: this.props.formData.boom_type,
                                                        })(
                                                            <Radio.Group>
                                                                {this.props.typeList.map((item, index) => (
                                                                    <Radio value={item.value}>{item.label}</Radio>
                                                                ))}
                                                            </Radio.Group>
                                                        )}
                                                    </Form.Item>
                                                    {(getFieldValue("boom_type") !== undefined ? getFieldValue("boom_type") : this.props.formData.boom_type) === 1 && (
                                                        <Form.Item
                                                            label={
                                                                <span>
                                                                    {this.props.language["leaveCondition"]}：
                                                                    {
                                                                        this.props.configData.conf.boomHands[
                                                                        getFieldValue("boom_hand") !== undefined ? getFieldValue("boom_hand") : this.props.formData.boom_hand
                                                                        ]
                                                                    }
                                                                    {this.props.language["hand"]}
                                                                </span>
                                                            }
                                                        >
                                                            {getFieldDecorator("boom_hand", {
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            this.props.language["leaveConditionVerify"],
                                                                    },
                                                                ],
                                                                initialValue: this.props.formData.boom_hand,
                                                            })(
                                                                <Slider
                                                                    dots
                                                                    tipFormatter={(value) =>
                                                                        String(
                                                                            this.props.configData.conf.boomHands[value]
                                                                        ) + this.props.language["hand"]
                                                                    }
                                                                    min={0}
                                                                    max={
                                                                        this.props.configData.conf.boomHands.length - 1
                                                                    }
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    )}
                                                    {(getFieldValue("boom_type") !== undefined ? getFieldValue("boom_type") : this.props.formData.boom_type) === 2 && (
                                                        <Form.Item
                                                            label={
                                                                <span>
                                                                    {this.props.language["leaveCondition"]}：
                                                                    {
                                                                        this.props.configData.conf.boomMinutes[
                                                                        getFieldValue("boom_minute") !== undefined ? getFieldValue("boom_minute") : this.props.formData.boom_minute
                                                                        ]
                                                                    }
                                                                    {this.props.language["minute"]}
                                                                </span>
                                                            }
                                                        >
                                                            {getFieldDecorator("boom_minute", {
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            this.props.language["leaveConditionVerify"],
                                                                    },
                                                                ],
                                                                initialValue: this.props.formData.boom_minute,
                                                            })(
                                                                <Slider
                                                                    dots
                                                                    tipFormatter={(value) =>
                                                                        String(
                                                                            this.props.configData.conf.boomMinutes[value]
                                                                        ) + this.props.language["minute"]
                                                                    }
                                                                    min={0}
                                                                    max={
                                                                        this.props.configData.conf.boomMinutes.length -
                                                                        1
                                                                    }
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}

                                {/* 入池标准 */}
                                {this.props.configData.kind === 1 && (
                                    <>
                                        <Form.Item label={this.props.language["entryPoolStandard"]}>
                                            {getFieldDecorator("is_sit_vpip", {
                                                initialValue: this.props.formData.is_sit_vpip,
                                                valuePropName: "checked",
                                            })(<Switch />)}
                                        </Form.Item>
                                        {(getFieldValue("is_sit_vpip") !== undefined ? getFieldValue("is_sit_vpip") : this.props.formData.is_sit_vpip) && (
                                            <>
                                                <Form.Item
                                                    label={
                                                        <span>
                                                            {this.props.language["sitEntryPoolRate"]}：
                                                            {this.props.configData.conf.canSitVpips[
                                                                getFieldValue("can_sit_vpip") !== undefined ? getFieldValue("can_sit_vpip") : this.props.formData.can_sit_vpip
                                                            ] / 100}
                                                            %
                                                        </span>
                                                    }
                                                >
                                                    {getFieldDecorator("can_sit_vpip", {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message:
                                                                    this.props.language["sitEntryPoolRateVerify"],
                                                            },
                                                        ],
                                                        initialValue: this.props.formData.can_sit_vpip,
                                                    })(
                                                        <Slider
                                                            dots
                                                            tipFormatter={(value) =>
                                                                String(
                                                                    this.props.configData.conf.canSitVpips[value] /
                                                                    100
                                                                ) + "%"
                                                            }
                                                            min={0}
                                                            max={
                                                                this.props.configData.conf.canSitVpips.length - 1
                                                            }
                                                        />
                                                    )}
                                                </Form.Item>
                                                <Form.Item
                                                    label={
                                                        <span>
                                                            {this.props.language["currentEntryPoolStandard"]}：
                                                            {this.props.configData.conf.checkSitVpips[
                                                                getFieldValue("check_sit_vpip") !== undefined ? getFieldValue("check_sit_vpip") : this.props.formData.check_sit_vpip
                                                            ] / 100}
                                                            %
                                                        </span>
                                                    }
                                                >
                                                    {getFieldDecorator("check_sit_vpip", {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message:
                                                                    this.props.language[
                                                                    "currentEntryPoolStandardVerify"
                                                                    ],
                                                            },
                                                        ],
                                                        initialValue: this.props.formData.check_sit_vpip,
                                                    })(
                                                        <Slider
                                                            dots
                                                            tipFormatter={(value) =>
                                                                String(
                                                                    this.props.configData.conf.checkSitVpips[
                                                                    value
                                                                    ] / 100
                                                                ) + "%"
                                                            }
                                                            min={0}
                                                            max={
                                                                this.props.configData.conf.checkSitVpips.length -
                                                                1
                                                            }
                                                        />
                                                    )}
                                                </Form.Item>
                                                <Form.Item
                                                    label={
                                                        <span>
                                                            {this.props.language["detectionHandNumber"]}：
                                                            {
                                                                this.props.configData.conf.checkSitVpipBeginHands[
                                                                getFieldValue("check_sit_vpip_begin_hand") !== undefined ? getFieldValue("check_sit_vpip_begin_hand") : this.props.formData.check_sit_vpip_begin_hand
                                                                ]
                                                            }
                                                            {this.props.language["hand"]}
                                                        </span>
                                                    }
                                                >
                                                    {getFieldDecorator("check_sit_vpip_begin_hand", {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message:
                                                                    this.props.language[
                                                                    "detectionHandNumberVerify"
                                                                    ],
                                                            },
                                                        ],
                                                        initialValue:
                                                            this.props.formData.check_sit_vpip_begin_hand,
                                                    })(
                                                        <Slider
                                                            dots
                                                            tipFormatter={(value) =>
                                                                String(
                                                                    this.props.configData.conf
                                                                        .checkSitVpipBeginHands[value]
                                                                ) + this.props.language["hand"]
                                                            }
                                                            min={0}
                                                            max={
                                                                this.props.configData.conf.checkSitVpipBeginHands
                                                                    .length - 1
                                                            }
                                                        />
                                                    )}
                                                </Form.Item>
                                            </>
                                        )}
                                    </>
                                )}

                                {/* 鱿鱼游戏 */}
                                {this.props.configData.kind === 1 && (
                                    <>
                                        <Form.Item label={this.props.language["squidGame"]}>
                                            {getFieldDecorator("is_squid", {
                                                initialValue: this.props.formData.is_squid,
                                                valuePropName: "checked",
                                            })(
                                                (
                                                    (getFieldValue("is_rathole") !== undefined ? getFieldValue("is_rathole") : this.props.formData.is_rathole) ||
                                                    (getFieldValue("is_call_time") !== undefined ? getFieldValue("is_call_time") : this.props.formData.is_call_time) ||
                                                    (getFieldValue("is_sushi") !== undefined ? getFieldValue("is_sushi") : this.props.formData.is_sushi)
                                                ) ? (
                                                    <Tooltip
                                                        placement="right"
                                                        title={this.props.language["squidDisabledTips"]}
                                                    >
                                                        <Switch disabled={
                                                            (getFieldValue("is_rathole") !== undefined ? getFieldValue("is_rathole") : this.props.formData.is_rathole) ||
                                                            (getFieldValue("is_call_time") !== undefined ? getFieldValue("is_call_time") : this.props.formData.is_call_time) ||
                                                            (getFieldValue("is_sushi") !== undefined ? getFieldValue("is_sushi") : this.props.formData.is_sushi)
                                                        } />
                                                    </Tooltip>
                                                ) : (
                                                    <Switch />
                                                )
                                            )}
                                        </Form.Item>
                                        {(getFieldValue("is_squid") !== undefined ? getFieldValue("is_squid") : this.props.formData.is_squid) && (
                                            <>
                                                <Form.Item
                                                    label={<span>{this.props.language["squidMode"]}</span>}
                                                >
                                                    {getFieldDecorator("squid_mode", {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: this.props.language["squidModeVerify"],
                                                            },
                                                        ],
                                                        initialValue: this.props.formData.squid_mode,
                                                    })(
                                                        <Radio.Group>
                                                            {this.props.squidTypeList.map((item, index) => (
                                                                <Radio value={item.value}>{item.label}</Radio>
                                                            ))}
                                                        </Radio.Group>
                                                    )}
                                                </Form.Item>
                                                <Form.Item
                                                    label={
                                                        <span>
                                                            {this.props.language["squidValue"]}：
                                                            {this.props.configData.conf.squidBBs[
                                                                getFieldValue("squid_bb") !== undefined ? getFieldValue("squid_bb") : this.props.formData.squid_bb
                                                            ] / 2}
                                                            BB
                                                        </span>
                                                    }
                                                >
                                                    {getFieldDecorator("squid_bb", {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: this.props.language["squidValueVerify"],
                                                            },
                                                        ],
                                                        initialValue: this.props.formData.squid_bb,
                                                    })(
                                                        <Slider
                                                            dots
                                                            tipFormatter={(value) =>
                                                                String(
                                                                    this.props.configData.conf.squidBBs[value] / 2
                                                                ) + "BB"
                                                            }
                                                            min={0}
                                                            max={this.props.configData.conf.squidBBs.length - 1}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </>
                                        )}
                                    </>
                                )}
                                {/* 寿司游戏 */}
                                {this.props.configData.kind === 1 && (
                                    <>
                                        <Form.Item label={this.props.language["sushiGame"]}>
                                            {getFieldDecorator("is_sushi", {
                                                initialValue: this.props.formData.is_sushi,
                                                valuePropName: "checked",
                                            })(
                                                (
                                                    (getFieldValue("is_boom") !== undefined ? getFieldValue("is_boom") : this.props.formData.is_boom) ||
                                                    (getFieldValue("is_squid") !== undefined ? getFieldValue("is_squid") : this.props.formData.is_squid)
                                                ) ? (
                                                    <Tooltip
                                                        placement="right"
                                                        title={this.props.language["sushiDisabledTips"]}
                                                    >
                                                        <Switch disabled={
                                                            (getFieldValue("is_boom") !== undefined ? getFieldValue("is_boom") : this.props.formData.is_boom) ||
                                                            (getFieldValue("is_squid") !== undefined ? getFieldValue("is_squid") : this.props.formData.is_squid)
                                                        } />
                                                    </Tooltip>
                                                ) : (
                                                    <Switch />
                                                )
                                            )}
                                        </Form.Item>
                                        {(getFieldValue("is_sushi") !== undefined ? getFieldValue("is_sushi") : this.props.formData.is_sushi) && (
                                            <>
                                                <Form.Item
                                                    label={
                                                        <span>
                                                            {this.props.language["initialBet"]}：
                                                            {this.props.configData.conf.sushiBaseAnte[
                                                                getFieldValue("sushi_base_ante") !== undefined ? getFieldValue("sushi_base_ante") : this.props.formData.sushi_base_ante
                                                            ]}
                                                            BB
                                                        </span>
                                                    }
                                                >
                                                    {getFieldDecorator("sushi_base_ante", {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: this.props.language["initialBetVerify"],
                                                            },
                                                        ],
                                                        initialValue: this.props.formData.sushi_base_ante,
                                                    })(
                                                        <Slider
                                                            dots
                                                            tipFormatter={(value) =>
                                                                String(
                                                                    this.props.configData.conf.sushiBaseAnte[value]
                                                                ) + "BB"
                                                            }
                                                            min={0}
                                                            max={this.props.configData.conf.sushiBaseAnte.length - 1}
                                                        />
                                                    )}
                                                </Form.Item>
                                                <Form.Item
                                                    label={
                                                        <span>
                                                            {this.props.language["littleBlindBet"]}：
                                                            {this.props.configData.conf.sushiSeatAnte[
                                                                getFieldValue("sushi_seat_ante") !== undefined ? getFieldValue("sushi_seat_ante") : this.props.formData.sushi_seat_ante
                                                            ]}
                                                            BB
                                                        </span>
                                                    }
                                                >
                                                    {getFieldDecorator("sushi_seat_ante", {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: this.props.language["littleBlindBetVerify"],
                                                            },
                                                        ],
                                                        initialValue: this.props.formData.sushi_seat_ante,
                                                    })(
                                                        <Slider
                                                            dots
                                                            tipFormatter={(value) =>
                                                                String(
                                                                    this.props.configData.conf.sushiSeatAnte[value]
                                                                ) + "BB"
                                                            }
                                                            min={0}
                                                            max={this.props.configData.conf.sushiSeatAnte.length - 1}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </>
                                        )}
                                    </>
                                )}
                                {/* 随机座位 */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 2 ||
                                    this.props.configData.kind === 4 ||
                                    this.props.configData.kind === 8) && (

                                        <Form.Item label={this.props.language["randomSeat"]}>
                                            {getFieldDecorator("random_seat", {
                                                initialValue: this.props.formData.random_seat,
                                                valuePropName: "checked",
                                            })(<Switch />)}
                                        </Form.Item>
                                    )}

                                {/* 癞子 */}
                                {this.props.configData.kind === 6 && (
                                    <Form.Item label={this.props.language["lame"]}>
                                        {getFieldDecorator("magic_card", {
                                            initialValue: this.props.formData.magic_card,
                                            valuePropName: "checked",
                                        })(<Switch />)}
                                    </Form.Item>
                                )}

                                {/* 保险模式 */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 2 ||
                                    this.props.configData.kind === 4) && (
                                        <Form.Item label={this.props.language["insuranceMode"]}>
                                            {getFieldDecorator("is_insurance", {
                                                initialValue: this.props.formData.is_insurance,
                                                valuePropName: "checked",
                                            })(<Switch />)}
                                        </Form.Item>
                                    )}

                                {/* 房间内Cowboy */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 2 ||
                                    this.props.configData.kind === 4 ||
                                    this.props.configData.kind === 8) && (
                                        <Form.Item
                                            label={
                                                <>
                                                    <span>{this.props.language["isRoomCowboy"]}</span>
                                                    <span style={{ color: "#ff4d4f" }}>
                                                        （
                                                        {this.props.configData.conf.cowboyCostDiscount[
                                                            getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                        ] === 0 ? (
                                                            <span>
                                                                {this.props.language["freeLimitedTime"]}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                <span>
                                                                    {
                                                                        this.props.language[
                                                                        "everyHoursConsumeDiamond"
                                                                        ]
                                                                    }
                                                                    ：
                                                                </span>
                                                                <span
                                                                    style={{
                                                                        textDecoration: "line-through",
                                                                        marginRight: 5,
                                                                    }}
                                                                >
                                                                    {this.props.language["originalPrice"]}：
                                                                    {
                                                                        this.props.configData.conf.cowboyCost[
                                                                        getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                                        ]
                                                                    }
                                                                </span>
                                                                ；
                                                                <span>
                                                                    {this.props.language["currentPrice"]}：
                                                                    {
                                                                        this.props.configData.conf.cowboyCostDiscount[
                                                                        getFieldValue("blind") !== undefined ? getFieldValue("blind") : this.props.formData.blind
                                                                        ]
                                                                    }
                                                                </span>
                                                            </span>
                                                        )}
                                                        ）
                                                    </span>
                                                </>
                                            }
                                        >
                                            {getFieldDecorator("show_cowboy", {
                                                initialValue: this.props.formData.show_cowboy,
                                                valuePropName: "checked",
                                            })(<Switch />)}
                                        </Form.Item>
                                    )}

                                {/* 补盲 */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 8 ||
                                    this.props.configData.kind === 4) && (
                                        <Form.Item label={this.props.language["blind"]}>
                                            {getFieldDecorator("force_blind", {
                                                initialValue: this.props.formData.force_blind,
                                                valuePropName: "checked",
                                            })(<Switch />)}
                                        </Form.Item>
                                    )}

                                {/* 强制Straddle */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 4) && (
                                        <Form.Item label={this.props.language["straddle"]}>
                                            {getFieldDecorator("is_straddle", {
                                                initialValue: this.props.formData.is_straddle,
                                                valuePropName: "checked",
                                            })(<Switch />)}
                                        </Form.Item>
                                    )}

                                {/* 强制亮牌 */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 2 ||
                                    this.props.configData.kind === 4 ||
                                    this.props.configData.kind === 8) && (
                                        <Form.Item label={this.props.language["showHands"]}>
                                            {getFieldDecorator("is_show_all_hands", {
                                                initialValue: this.props.formData.is_show_all_hands,
                                                valuePropName: "checked",
                                            })(<Switch />)}
                                        </Form.Item>
                                    )}

                                {/* 顺序开牌 */}
                                {(this.props.configData.kind === 1 ||
                                    this.props.configData.kind === 2 ||
                                    this.props.configData.kind === 4 ||
                                    this.props.configData.kind === 8) && (
                                        <Form.Item label={this.props.language["openCard"]}>
                                            {getFieldDecorator("is_friend_limit", {
                                                initialValue: this.props.formData.is_friend_limit,
                                                valuePropName: "checked",
                                            })(<Switch />)}
                                        </Form.Item>
                                    )}

                                {/* IP&GPS限制 */}
                                <Form.Item label={this.props.language["ipAndGpsLimit"]}>
                                    {getFieldDecorator("is_ip_gps_limit", {
                                        initialValue: this.props.formData.is_ip_gps_limit,
                                        valuePropName: "checked",
                                    })(<Switch />)}
                                </Form.Item>

                                {/* 关闭聊天 */}
                                <Form.Item label={this.props.language["closeChat"]}>
                                    {getFieldDecorator("is_close_chat", {
                                        initialValue: this.props.formData.is_close_chat,
                                        valuePropName: "checked",
                                    })(<Switch />)}
                                </Form.Item>

                                {/* 禁用模拟器 */}
                                <Form.Item label={this.props.language["disableSimulator"]}>
                                    {getFieldDecorator("block_simulator", {
                                        initialValue: this.props.formData.block_simulator,
                                        valuePropName: "checked",
                                    })(<Switch />)}
                                </Form.Item>

                                {/* 自动重建房间 */}
                                {/* <Form.Item label="自动重建房间">
                                    {getFieldDecorator('auto_create_match', {
                                        initialValue: this.props.formData.auto_create_match,
                                        valuePropName: "checked",
                                    })(
                                        <Switch />
                                    )}
                                </Form.Item> */}
                            </Form>
                        </div>
                    )}
                </Modal>
            );
        }
    }
);

/**
 * 导入配置表单弹窗
 */
const ImprotFormModal = Form.create({ name: "import_form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form;
            const kind = this.props.kindList.find(
                (item) => item.value === this.props.queryParams.kind
            );
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={() => this.props.onCancel("importConfig")}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item label={this.props.getLanguage("gameMatchCnfig", kind.label)}>
                                {getFieldDecorator("id", {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.getLanguage("gameMatchCnfigVerify", kind.label),
                                        },
                                    ],
                                })(
                                    <Select
                                        loading={this.props.loading}
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder={this.props.getLanguage("gameMatchCnfigPlaceholder", kind.label)}
                                    >
                                        {this.props.configList.map((item, index) => (
                                            <Select.Option key={index} value={item.id}>
                                                {item.default_name}（{item.id}）
                                            </Select.Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            );
        }
    }
);

/**
 * 导入多个配置弹窗
 */
const ImprotAllFormModal = Form.create({ name: 'import_all_form_model' })(
    class FormBox extends React.Component {
        /**
         * 上传前
         */
        MAX_SIZE = 10 // 最大上传大小限制
        beforeUpload = (file) => {
            const acceptList = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
            const isAcceptedType = acceptList.includes(file.type)
            if (!isAcceptedType) {
                message.error(this.props.getLanguage("uploadeTypeMessage", 'XLSX'))
                return false
            }
            const isAcceptedLimit = file.size / 1024 / 1024 < this.MAX_SIZE
            if (!isAcceptedLimit) {
                message.error(this.props.getLanguage("uploadeSizeMessage", this.MAX_SIZE))
                return false
            }
            return true
        };

        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={() => this.props.onCancel("importAllConfig")}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto'
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item label={this.props.language["configFile"]}>
                                {getFieldDecorator('uri', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["configFileVerify"]
                                        }
                                    ],
                                    initialValue: this.props.importAllformData.uri
                                })(
                                    <>
                                        <Upload
                                            name="file"
                                            accept=".xlsx"
                                            listType="text"
                                            disabled={this.props.uploadConfigLoading}
                                            showUploadList={false}
                                            beforeUpload={this.beforeUpload}
                                            customRequest={this.props.handleUploadConfig}
                                        >
                                            {getFieldValue('uri') && !this.props.uploadConfigLoading ? (
                                                <Alert style={{ cursor: "pointer" }} message={this.props.uploadFile.name} type="info" />
                                            ) : (
                                                <Button>
                                                    <Icon
                                                        type={this.props.uploadConfigLoading ? 'loading' : 'plus'}
                                                    />
                                                    Upload
                                                </Button>
                                            )}
                                        </Upload>
                                        <div
                                            style={{
                                                fontSize: '14px',
                                                color: '#999'
                                            }}
                                        >
                                            <p>{this.props.getLanguage("suggestSize", this.MAX_SIZE)} </p>
                                        </div>
                                    </>
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            )
        }
    }
)
